// import { Note, ... } from '../../_service/data.service';
// src/app/edit/edit-component.ts
// This file implements the edit note page. It is based on Angular forms and PrimeNG components.
import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  ElementRef,
  AfterViewInit,
  Renderer2,
  HostListener,
  inject,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { CommonModule, Location } from '@angular/common';
import { RouterModule, Router, CanDeactivate } from '@angular/router';
import { ChangeDetectorRef } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
  ValidationErrors,
  ValidatorFn,
  FormRecord,
} from '@angular/forms';
import { forkJoin, firstValueFrom, Subscription, Subject, Observable } from 'rxjs';
import { filter, switchMap, takeUntil } from 'rxjs/operators';
import { CanComponentDeactivate } from '../../_guards/unsaved-changes.guard';

import { MenuModule } from 'primeng/menu';
import { MenuItem, MessageService, ConfirmationService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { SelectModule } from 'primeng/select';
import { MultiSelectModule } from 'primeng/multiselect';
import { TreeSelectModule } from 'primeng/treeselect';
import { TreeNode } from 'primeng/api';
import { StyleClassModule } from 'primeng/styleclass';
import { SliderModule } from 'primeng/slider';
import { PopoverModule } from 'primeng/popover';
import { DatePickerModule } from 'primeng/datepicker';
import { DialogModule } from 'primeng/dialog';
import { TableModule } from 'primeng/table';
import { TooltipModule } from 'primeng/tooltip';
import { InputTextModule } from 'primeng/inputtext';
import { ChipModule } from 'primeng/chip';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { SplitButtonModule } from 'primeng/splitbutton';

import { LayoutService } from '../../_service/layout.service';
import { AppConfig } from '../user-settings/app.config';

import {
  Note,
  Category,
  Tag,
  TagMutationPayload,
  DataService,
  ApiResponse,
  SimilarNoteResult,
  SuggestedTagResult,
  AiSummary,
  NoteEditSessionSnapshot,
  NoteEditSessionSnapshotContent,
} from '../../_service/data.service';
//import { OLD__UserSettingsService } from '../../_service/OLD_usersettings.service';
import { NavigationService } from '../../_service/navigation.service';
import { SnackbarService } from '../../_service/snackbar.service';
import { AlertService, AlertType } from '../../_service/alert.service'; // Adjust path as needed
import { UserSettingsService } from '../../_service/user-settings.service';
import { DialogType, GlobalDialogService } from '../../_service/global-dialog.service';
import { EnvironmentService } from '../../_service/sync/environment.service';
import { ConnectivityDisplay, resolveConnectivityDisplay } from '../home/logic/sync-state.logic';
import { EditSessionService } from '../../_service/edit-session.service';
import { SyncCoordinatorService } from '../../_service/sync/sync-coordinator.service';
import { UnsavedChangesStateService } from '../../_service/unsaved-changes-state.service';
import { formatPersistedNoteSize } from '../../_util/note-size.util';
import { getOrderedRelatedNoteIds, toRelatedNotesPayload } from '../../_util/related-notes.util';
import { extractSnapshotContent } from '../../_util/note-snapshot.util';
import { AiSessionService } from '../../_service/ai-session.service';

import { AlertComponent } from '../alert/alert.component';
import { RichEditorComponent } from '../rich-editor/rich-editor.component';
import { FileUploadComponent } from '../file-upload/file-upload.component';

// import type Delta from 'quill-delta';
// import Delta from 'quill-delta';
import Delta from 'quill-delta';

interface NewNoteResponse {
  message: string;
  id: string; // Changed from number to string as per your requirement
}

interface SuggestedTagSelection {
  _id: string;
  name: string;
  description: string;
  selected: boolean;
}

interface SimilarNoteSelectionItem {
  _id?: string;
  id?: string;
  title?: string;
  Status?: string;
  updated_at?: string;
  modified_at?: string;
  modifiedDate?: string;
  last_modified?: string;
  final_score?: number;
  semantic_score?: number;
  selected: boolean;
  [key: string]: unknown;
}

@Component({
  selector: 'edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    RichEditorComponent,
    FileUploadComponent,
    MenuModule,
    ButtonModule,
    AppConfig,
    StyleClassModule,
    ReactiveFormsModule,
    SelectModule,
    TreeSelectModule,
    MultiSelectModule,
    SliderModule,
    PopoverModule,
    DatePickerModule,
    DialogModule,
    TableModule,
    TooltipModule,
    InputTextModule,
    ChipModule,
    AutoCompleteModule,
    AlertComponent,
    ConfirmDialogModule,
    SplitButtonModule,
  ],
  providers: [ConfirmationService],
  // standalone: true,
})
export class EditComponent implements OnInit, OnDestroy, CanComponentDeactivate {
  @ViewChild('red-button') myButton!: ElementRef;
  @ViewChild('TitleField') TitleField!: ElementRef<HTMLInputElement>;
  @ViewChild('editorContainer', { static: true }) editorContainer!: ElementRef<HTMLDivElement>;
  //   @ViewChild(FileUploadComponent) fileUploadComponent!: FileUploadComponent;
  @ViewChild(FileUploadComponent, { static: false }) fileUploadComponent!: FileUploadComponent;
  @ViewChild('descriptionEditor') descriptionEditor!: RichEditorComponent;
  //layoutService: LayoutService = inject(LayoutService);
  note!: Note;
  noteId: string = '';
  statusValues: string[] | undefined;
  types: string[] | undefined;
  all_categories: Category[] | undefined;
  categories_tree: TreeNode[] = []; // For tree element

  editNoteForm!: FormGroup;
  exitOnSaveFlag: boolean = false;
  isHeaderVisible: boolean = false;
  isMetadataMoreVisible: boolean = false;
  isDescriptionExpanded: boolean = true;
  isFileAttachmentsExpanded: boolean = false;
  isTagsExpanded: boolean = false;
  isKeywordsExpanded: boolean = false;
  isCommentsExpanded: boolean = false;
  areAllCollapsibleExpanded: boolean = true;
  isFavorite: boolean = false;
  favoriteNoteIds: string[] = [];
  MobileMenuIsVisible: boolean = false;
  isContentChanged: boolean = false;
  isCategoriesChanged: boolean = false;
  isInitializing: boolean = true; // Flag to prevent change detection during initialization
  loadingCounter = 0; // initially count of loading objects in progress
  private contentChangeCounter = 0;
  isSaving = false;
  tempMessage: string = '';
  statusMessage: string = '';
  editorZoomFactor: number = 150;
  private routeParamSub?: Subscription;
  private activeEditSessionNoteId: string | null = null;

  temporaryStatus: boolean = false; // Will be set to true if loaded Note has not been saved yet (='Temp')

  categoryItems: { _id: string; ItemName: string; isSelected?: Boolean }[] = []; // List of items to select from
  selectedCategoryIDs: string[] = [];
  filter: any; // DEBUG- copied from view.component.ts; not implemented!
  homeState: { view?: string; calendarMonth?: string } | null = null;
  menuItems: MenuItem[] = [];
  availableTags: Tag[] = [];
  filteredTagSuggestions: Tag[] = [];
  noteTags: Tag[] = [];
  quickTagName: string | Tag = '';
  filteredParentTagSuggestions: Tag[] = [];
  readonly tagTypeOptions: string[] = [
    'calendar',
    'concept',
    'location',
    'organization',
    'person',
    'project',
    'topic',
    'technology',
  ];
  readonly defaultTagType = 'topic';
  readonly unsortedCategoryId = 'category:41';
  tagDialogVisible = false;
  isTagMutating = false;
  editingTagIndex: number | null = null;
  tagDraftId = '';
  tagDraftRev: string | undefined = undefined;
  tagDraftName = '';
  tagDraftType = this.defaultTagType;
  tagDraftSlug = '';
  tagDraftColor = '#2563EB';
  tagDraftIcon = '';
  tagDraftParentTagId = '';
  tagDraftParentTag: string | Tag = '';
  tagDraftSortOrder: number | null = null;
  tagDraftIsActive = true;
  aiKeywordsLoading = false;
  aiSuggestTagsLoading = false;
  aiSummaryLoading = false;
  aiSuggestTagsDialogVisible = false;
  aiSuggestedTags: SuggestedTagSelection[] = [];
  saveTemplateDialogVisible = false;
  templateName = '';

  // Related Notes state
  relatedNotes: string[] = [];
  isRelatedNotesExpanded = false;
  addRelatedNoteDialogVisible = false;
  addRelatedNoteCreateBacklink = true;
  relatedNoteSearchQuery = '';
  relatedNoteSearchResults: Note[] = [];
  similarForLinkDialogVisible = false;
  similarForLinkLoading = false;
  similarForLinkResults: SimilarNoteSelectionItem[] = [];
  similarForLinkError = '';
  createBacklinksChecked = true;
  removeRelatedNoteDialogVisible = false;
  removeRelatedNotePendingIndex = -1;
  removeRelatedNotePendingId = '';
  removeRelatedNotePendingTitle = '';
  removeRelatedNoteDeleteBacklink = true;
  removeRelatedNoteHasBacklink = false;

  similarNotesDialogVisible = false;
  similarNotesLoading = false;
  similarNotesResults: SimilarNoteResult[] = [];
  similarNotesError = '';
  templateNameTouched = false;
  isSavingTemplate = false;
  isOnline: boolean = true; // Tracks online/offline status from EnvironmentService
  // Whether the server actually responded to the last sync attempt — distinct from
  // isOnline, which only reflects the browser's network interface. See SyncStateLogic.
  serverReachable: boolean = true;
  get connectivity(): ConnectivityDisplay {
    return resolveConnectivityDisplay(this.isOnline, this.serverReachable);
  }
  private offlineSaveDialogShown = false;
  private destroy$ = new Subject<void>();
  unsavedChangesDialogVisible = false;
  pendingCancelEdits = false;
  private deactivateResolver: ((value: boolean) => void) | null = null;

  // ---- Autosave (Stage 1) ----
  private static readonly AUTOSAVE_DEBOUNCE_MS = 5000;
  private static readonly AUTOSAVE_MAX_INTERVAL_MS = 25000;
  autosaveEnabled = true;
  autosaveState: 'saved' | 'unsaved' | 'saving-local' | 'saved-local' | 'syncing' | 'sync-failed' = 'saved';
  private autosaveDebounceTimer: ReturnType<typeof setTimeout> | null = null;
  private autosaveMaxTimer: ReturnType<typeof setTimeout> | null = null;
  private autosaveInFlight = false;
  private autosavePendingRerun = false;
  private autosaveLastSavedGeneration = 0;
  private autosaveSyncSub?: Subscription;

  // ---- Autosave (Stage 2 — session snapshot & discard) ----
  private openingSnapshot: NoteEditSessionSnapshot | null = null;
  private openingSnapshotBaselineCounter = 0;
  private discardInvokedViaClose = false;
  /** Dropdown model for the footer's Close SplitButton (autosave mode only). */
  closeSplitMenuItems: MenuItem[] = [
    {
      label: 'Discard changes since opening…',
      icon: 'pi pi-history',
      disabled: true,
      command: () => this.openDiscardChangesDialog(true),
    },
  ];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private data_service: DataService,
    private location: Location,
    private cdRef: ChangeDetectorRef,
    private fb: FormBuilder,
    private snackbarService: SnackbarService,
    private messages: MessageService,
    //private userSettingsService: OLD__UserSettingsService,
    private userSettings: UserSettingsService,
    private layoutService: LayoutService, // 👈 add this
    private navigationService: NavigationService,
    private titleService: Title,
    private renderer: Renderer2,
    private alertService: AlertService,
    private gDS: GlobalDialogService,
    private elRef: ElementRef,
    private environmentService: EnvironmentService,
    private confirmationService: ConfirmationService,
    private editSessionService: EditSessionService,
    private unsavedChangesState: UnsavedChangesStateService,
    private aiSessionService: AiSessionService,
    private syncCoordinator: SyncCoordinatorService,
  ) {}

  openAskNotes(): void {
    const formValue = this.editNoteForm?.value;
    const descriptionHtml = formValue?.DescriptionHtml ?? this.note?.DescriptionHtml ?? '';
    const commentsHtml = formValue?.CommentsHtml ?? this.note?.CommentsHtml ?? '';

    this.aiSessionService.openDialog({
      currentNote: {
        noteId: this.note?._id,
        title: this.note?.Title,
        descriptionHtml,
        commentsHtml,
      },
    });
  }

  // ##############################################################################
  // INITIATION & DATA LOADING FUNCTIONS
  // ##############################################################################

  ngOnInit(): void {
    console.log('######In EditCopmponent -- ngOnInit()###########');
    this.loadingCounter = 0; // Start loading
    this.initializePageMenu();
    const navState = this.router.getCurrentNavigation()?.extras?.state ?? (history.state || {});
    this.filter = navState['filter'] ?? this.filter;
    this.homeState = navState['homeState'] ?? null;
    this.userSettings.loadSavedTheme();
    this.userSettings.userSettings$.subscribe((settings) => {
      console.log('[UserSettingsService] initialize(): loaded', settings);
      if (settings) {
        console.log('primaryColor from stream =', settings.primaryColor);
        if (settings.primaryColor) {
          this.layoutService.appState.update((state: any) => ({
            ...state,
            primary: settings.primaryColor,
          }));
        }
        const zoom = settings.editorZoomFactor ?? this.editorZoomFactor;
        this.editorZoomFactor = zoom;
        document.documentElement.style.setProperty('--fontScaleFactor', `${zoom}%`);
        document.documentElement.style.setProperty('--fontScaleRatio', `${zoom / 100}`);
        // document.documentElement.style.setProperty('--systemZoom', `${settings.systemZoomFactor}%`);
        // document.documentElement.style.setProperty('--systemZoom', `${200}%`);
      }
      this.autosaveEnabled = typeof settings?.autosaveEnabled === 'boolean' ? settings.autosaveEnabled : true;
      this.syncDiscardMenuItemState();
      this.favoriteNoteIds = this.normalizeFavoriteNoteIds(settings?.favoriteNoteIds);
      this.updateFavoriteState();
    });
    this.userSettings.editorZoomFactor$.subscribe((factor) => {
      if (typeof factor === 'number' && !Number.isNaN(factor)) {
        this.editorZoomFactor = factor;
        document.documentElement.style.setProperty('--fontScaleFactor', `${factor}%`);
        document.documentElement.style.setProperty('--fontScaleRatio', `${factor / 100}`);
      }
    });

    // Subscribe to network status changes
    this.environmentService.online$
      .pipe(takeUntil(this.destroy$))
      .subscribe((status) => {
        this.isOnline = status;
        if (status) {
          this.offlineSaveDialogShown = false;
        }
        this.updateAiMenuItems();
        this.cdRef.markForCheck();
      });

    // Server reachability - distinct from browser online/offline (see SyncStateLogic):
    // the browser can report "online" while the app's server is unreachable.
    this.syncCoordinator.serverReachable$
      .pipe(takeUntil(this.destroy$))
      .subscribe((reachable) => {
        this.serverReachable = reachable;
        this.cdRef.markForCheck();
      });

    // Refresh relatedNotes when a background sync updates IndexedDB,
    // but only if the user hasn't made unsaved changes yet.
    this.data_service.dataReloaded$
      .pipe(
        filter((v) => v !== null),
        filter(() => !!this.noteId && !this.isContentChanged),
        switchMap(() => this.data_service.getNote(this.noteId!)),
        filter((result) => result.status === 'success' && !!result.data),
        takeUntil(this.destroy$)
      )
      .subscribe((result) => {
        const note = result.data!;
        const rawRelated = Array.isArray((note as any).RelatedNotes)
          ? (note as any).RelatedNotes
          : Array.isArray((note as any).relatedNotes)
            ? (note as any).relatedNotes
            : [];
        const fresh = getOrderedRelatedNoteIds(rawRelated);
        if (fresh.join(',') !== this.relatedNotes.join(',')) {
          this.relatedNotes = fresh;
          this.refreshRelatedNoteObjects();
          this.cdRef.markForCheck();
        }
      });

    this.routeParamSub = this.route.paramMap.subscribe((params) => {
      const nextNoteId = String(params.get('_id'));

      if (this.activeEditSessionNoteId && this.activeEditSessionNoteId !== nextNoteId) {
        this.editSessionService.unregisterEditSession(this.activeEditSessionNoteId);
        this.activeEditSessionNoteId = null;
      }

      this.noteId = nextNoteId;
      this.registerCurrentEditSession();
      console.log('param id = ', this.noteId);
      this.loadData(this.noteId);
    });
  }

  onZoomFactorChange(type: 'system' | 'editor', event: any): void {
    if (type === 'editor') {
      console.log('Editor zoom factor changed to ', this.editorZoomFactor);
      this.userSettings.setEditorZoomFactor(this.editorZoomFactor);
    }
  }

  persistEditorZoom(): void {
    this.userSettings.setEditorZoomFactor(this.editorZoomFactor);
  }

  initializePageMenu() {
    this.menuItems = [
      {
        label: 'View item',
        icon: 'fas fa-eye mr-2 !text-red-500',
        styleClass: 'text-black m-2 full-hover', // Use a CSS class instead
        command: () => this.pageMenu('View'),
      },
      {
        label: 'User-Settings',
        icon: 'fas fa-cog mr-2 !text-blue-500',
        styleClass: 'text-black hover:!bg-blue-600 hover:text-white m-2', // Use a CSS class instead
        command: () => this.pageMenu('UserSettings'),
      },
      {
        label: 'Download PDF',
        icon: 'fas fa-file-pdf mr-2 !text-red-500',
        styleClass: 'text-black hover:!bg-blue-600 hover:text-white m-2', // Use a CSS class instead
        command: () => this.pageMenu('DownloadPDF'),
      },
      {
        label: 'Print',
        icon: 'fas fa-print mr-2 !text-blue-500',
        styleClass: 'text-black hover:!bg-blue-600 hover:text-white m-2', // Use a CSS class instead
        command: () => this.pageMenu('Print'),
      },
      {
        label: 'Save as Template...',
        icon: 'fas fa-copy mr-2 !text-blue-500',
        styleClass: 'text-black hover:!bg-blue-600 hover:text-white m-2',
        command: () => this.pageMenu('SaveAsTemplate'),
      },
      { separator: true }, // 🔹 Separator before "Close"
      { label: '––––––––––––––––', disabled: true, styleClass: 'text-gray-500' }, // ✅ Custom separator
      {
        label: 'DEBUG - show raw data',
        icon: 'fa-solid fa-bug-slash mr-2 !text-red-500',
        styleClass: 'text-black hover:!bg-blue-600 hover:text-white m-2', // Use a CSS class instead
        command: () => this.pageMenu('ShowRawData'),
      },
      {
        label: 'New note',
        icon: 'fa-solid fa-plus mr-2 !text-red-500',
        styleClass: 'text-black hover:!bg-blue-600 hover:text-white m-2', // Use a CSS class instead
        command: () => this.pageMenu('New'),
      },
      {
        label: 'Create copy of note...',
        icon: 'pi pi-copy mr-2 !text-blue-500',
        styleClass: 'text-black hover:!bg-blue-600 hover:text-white m-2',
        command: () => this.pageMenu('CreateCopy'),
      },
      {
        label: 'Delete note',
        icon: 'fa-solid fa-trash mr-2 !text-red-500',
        styleClass: 'text-black hover:!bg-blue-600 hover:text-white m-2', // Use a CSS class instead
        command: () => this.pageMenu('Delete'),
      },
      { label: '––––––––––––––––', disabled: true, styleClass: 'text-gray-500' }, // ✅ Custom separator

      {
        label: 'Find Similar Notes',
        icon: 'pi pi-sparkles mr-2',
        styleClass: 'text-black hover:!bg-blue-600 hover:text-white m-2',
        command: () => this.pageMenu('FindSimilar'),
      },
      {
        label: 'Discard changes since opening…',
        icon: 'pi pi-history mr-2 !text-orange-500',
        styleClass: 'text-black hover:!bg-blue-600 hover:text-white m-2',
        visible: false,
        disabled: true,
        command: () => this.openDiscardChangesDialog(false),
      },
      {
        label: 'Close',
        icon: 'fas fa-window-close mr-2 !text-red-500',
        styleClass: 'text-black hover:!bg-blue-600 hover:text-white m-2', // Use a CSS class instead
        command: () => this.pageMenu('Close'),
      },
    ];
    this.syncDiscardMenuItemState();
  }

  /** Keeps both "Discard changes since opening…" entries' visible/disabled
   * state current (the page menu item and the Close SplitButton's dropdown
   * item) — visible only when autosave is on, enabled only once content
   * actually differs from the opening snapshot. Mirrors the existing
   * updateAiMenuItems() pattern below: p-menu/p-splitButton re-read item
   * properties each time they render, so mutating them in place is enough —
   * no need to rebuild either array. */
  private syncDiscardMenuItemState(): void {
    const canDiscard = this.canDiscardSinceOpening;

    const pageMenuItem = this.menuItems.find((m) => m.label === 'Discard changes since opening…');
    if (pageMenuItem) {
      pageMenuItem.visible = this.autosaveEnabled;
      pageMenuItem.disabled = !canDiscard;
    }

    if (this.closeSplitMenuItems[0]) {
      this.closeSplitMenuItems[0].disabled = !canDiscard;
    }
  }

  private updateAiMenuItems(): void {
    const aiLabels = ['Find Similar Notes'];
    for (const item of this.menuItems) {
      if (item.label && aiLabels.includes(item.label)) {
        item.disabled = !this.isOnline;
        item.title = !this.isOnline ? 'AI features are only available in online mode' : undefined;
      }
    }
  }

  loadData(noteIdOverride?: string): void {
    console.log('Edit-component: in loadData()');

    this.statusValues = this.data_service.getAllStatuses();
    this.types = this.data_service.getAllNoteTypes();

    this.loadingCounter++;

    const noteId = noteIdOverride ?? this.noteId ?? String(this.route.snapshot.paramMap.get('_id'));
    const now = new Date().toISOString();

    forkJoin({
      noteResp: this.data_service.getNote(noteId),
      categoriesResp: this.data_service.getAllCategories(),
    }).subscribe({
      next: ({ noteResp, categoriesResp }) => {
        console.log('Edit-component loadData: forkJoin finished. Response:', noteResp);

        let note: Note;

        /* ============================================================
         NOTE HANDLING (existing OR new temp note)
         ============================================================ */

        if (noteResp.status === 'success' && noteResp.data) {
          // ✅ Existing note
          note = noteResp.data;
        } else if (noteId.startsWith('note:')) {
          // ✅ NEW TEMP NOTE (created but not yet persisted)
          console.warn('🆕 Note not found in DB — initializing temporary note:', noteId);

          note = {
            _id: noteId,
            type: 'note',

            Title: '',
            DescriptionDelta: new Delta(),
            DescriptionHtml: '',
            CommentsDelta: new Delta(),
            CommentsHtml: '',

            Keywords: '',
            AiKeywords: '',
            Categories: [],

            Status: 'Temp',
            NoteType: 'To Do',

            Project: 16,
            ProjectName: '',

            Confidential: false,
            ReferenceDate: now,

            Attachments: [],

            created_on: now,
            updated_on: now,
            last_modified: now,
          } as Note;

          this.temporaryStatus = true;
          this.isHeaderVisible = true;
        } else {
          // ❌ Invalid / missing note
          const msg = noteResp.error?.message || `Note not found for ID ${noteId}`;
          this.tempMessage = msg;
          console.warn('⚠️', msg);
          this.alertService?.warn?.(msg, { life: 4000 });
          return;
        }

        /* ============================================================
         CATEGORIES
         ============================================================ */

        let categories: Category[] = [];
        if (categoriesResp.status === 'success' && categoriesResp.data) {
          categories = categoriesResp.data;
        } else {
          const msg = categoriesResp.error?.message || 'Failed to load categories.';
          console.warn('⚠️', msg);
          this.alertService?.warn?.(msg, { life: 4000 });
        }

        // Render from the already-loaded tag cache instantly; refresh from the
        // server in the background (see refreshTagCatalogInBackground) rather
        // than blocking note rendering on a live network round-trip.
        const availableTags: Tag[] = Array.isArray(this.data_service.allTags) ? [...this.data_service.allTags] : [];

        /* ============================================================
         NORMALIZE NOTE FIELDS
         ============================================================ */

        const projects = this.data_service.getAllProjects();
        note.ProjectName = projects.find((p) => p.ID === note.Project)?.Name ?? 'Unknown Project';

        if (!note.ReferenceDate) {
          note.ReferenceDate = note.created_on;
        }

        if (note.Confidential == null) {
          note.Confidential = false;
        }

        if (!note.NoteType || String(note.NoteType).trim() === '') {
          note.NoteType = 'To Do';
        }

        if (note.Status === 'Temp') {
          this.temporaryStatus = true;
          this.isHeaderVisible = true;
          note.Status = 'Current';
        }

        note.Attachments = Array.isArray(note.Attachments) ? note.Attachments : [];
        this.availableTags = this.sortTagsByOrder(availableTags);
        this.noteTags = this.resolveNoteTags(note, this.availableTags);
        const rawRelated = Array.isArray((note as any).RelatedNotes)
          ? (note as any).RelatedNotes
          : Array.isArray((note as any).relatedNotes)
            ? (note as any).relatedNotes
            : [];
        this.relatedNotes = getOrderedRelatedNoteIds(rawRelated);
        this.refreshRelatedNoteObjects();

        /* ============================================================
         ASSIGN + BUILD UI STATE
         ============================================================ */

        this.note = note;
        this.updateFavoriteState();

        this.all_categories = categories;
        this.categories_tree = this.buildCategoryTree(categories);

        const nodeIndex = this.buildNodeIndex(this.categories_tree);
        const selectedIds: string[] = (note.Categories ?? []).map((c: any) =>
          typeof c === 'string' ? c : c?.key ?? String(c),
        );
        const selectedNodes = selectedIds.map((id) => nodeIndex.get(id)).filter((n): n is TreeNode => !!n);

        this.initializeEditNoteForm();
        this.editNoteForm.get('Categories')?.setValue(selectedNodes);
        // Normalize this.note to exactly match the freshly-initialized form
        // (a no-op today, nothing has been edited yet) so the opening
        // snapshot below is built from the same fields/shape a later
        // autosave would write, via the same existing code path.
        this.applyChangesToNoteFromForm();

        this.setTitle('Edit: ' + (note.Title || 'New Note'));
        this.editSessionService.registerEditSession(note._id, {
          route: `/edit/${encodeURIComponent(note._id)}`,
          title: note.Title || undefined,
        });
        this.openingSnapshot = null;
        this.openingSnapshotBaselineCounter = this.contentChangeCounter;
        if (this.autosaveEnabled) {
          void this.createOpeningSnapshot();
        }

        this.cdRef.detectChanges();
        this.setContentChanged(false);
        this.isInitializing = false;

        void this.refreshTagCatalogInBackground();
      },

      error: (err: any) => {
        console.error('❌ Edit-component: loadData() failed', err);
        this.alertService?.error?.('Failed to load note, categories, or tags.', { life: 5000 });
      },

      complete: () => {
        this.loadingCounter--;
      },
    });
  }

  private buildNodeIndex(nodes: TreeNode[], map = new Map<string, TreeNode>()): Map<string, TreeNode> {
    for (const n of nodes) {
      if (n.key) map.set(n.key, n);
      if (n.children?.length) this.buildNodeIndex(n.children, map);
    }
    return map;
  }

  /*** Recursively prints a TreeNode[] structure to the console */
  printTree(nodes: TreeNode[], level: number = 0): void {
    const indent = '  '.repeat(level);
    for (const node of nodes) {
      console.log(`${indent}- ${node.label} (${node.key})`);
      if (node.children && node.children.length > 0) {
        this.printTree(node.children, level + 1);
      }
    }
  }

  buildCategoryTree(categories: Category[]): TreeNode[] {
    const nodeMap = new Map<string, TreeNode>();
    const tree: TreeNode[] = [];

    console.log('📦 Input categories:', categories);

    // Step 1: Create all nodes
    for (const category of categories) {
      const node: TreeNode = {
        key: category._id,
        label: category.Name,
        data: category,
      };
      nodeMap.set(category._id, node);
    }

    // Step 2: Link each node to its parent if it has one
    for (const category of categories) {
      const node = nodeMap.get(category._id)!;

      if (category.Parent) {
        const parentNode = nodeMap.get(category.Parent);
        if (parentNode) {
          if (!parentNode.children) {
            parentNode.children = [];
          }
          parentNode.children.push(node);
        } else {
          console.warn(`⚠️ Parent not found for category: ${category._id}, Parent: ${category.Parent}`);
        }
      } else {
        // Root node
        tree.push(node);
      }
    }

    // Step 3: Mark leaf nodes and sort children
    for (const node of nodeMap.values()) {
      if (!node.children || node.children.length === 0) {
        node.leaf = true;
      } else {
        // ✅ Sort children alphabetically, case-insensitive
        node.children.sort((a, b) => (a.label ?? '').localeCompare(b.label ?? '', undefined, { sensitivity: 'base' }));
      }
    }

    // ✅ Sort root nodes too
    tree.sort((a, b) => (a.label ?? '').localeCompare(b.label ?? '', undefined, { sensitivity: 'base' }));

    return tree;
  }

  initializeEditNoteForm(): void {
    // Initialize the form group after note is assigned
    this.editNoteForm = this.fb.group({
      Title: [this.note.Title, Validators.required],
      // Canonical format (Delta)
      DescriptionDelta: [this.note.DescriptionDelta ?? new Delta(), Validators.required],
      CommentsDelta: [this.note.CommentsDelta ?? new Delta()],

      // Derived format (HTML)
      DescriptionHtml: [this.note.DescriptionHtml ?? ''],
      CommentsHtml: [this.note.CommentsHtml ?? ''],

      //Description: [this.note.Description, Validators.required],
      //Comments: [this.note.Comments],
      Status: [this.note.Status, Validators.required],
      ReferenceDate: [this.note.ReferenceDate ? new Date(this.note.ReferenceDate) : new Date(this.note.created_on)],
      StartDate: [this.note.StartDate ? new Date(this.note.StartDate) : null],
      EndDate: [this.note.EndDate ? new Date(this.note.EndDate) : null],
      Confidential: [this.note.Confidential ?? false],
      NoteType: [this.note.NoteType ?? 'To Do', Validators.required],
      //Categories: [this.note.Categories],
      Categories: [this.selectedCategoryIDs],
      //Attachments: [this.note.Attachments ?? []], // ✅ always defined

      Tags: [this.noteTags.map((tag) => tag._id)],
      Keywords: [this.note.Keywords],
      AiKeywords: [(this.note as any).AiKeywords ?? ''],
    });
  }

  ngOnDestroy(): void {
    this.unsavedChangesState.setHasUnsavedChanges(false);
    if (this.activeEditSessionNoteId) {
      this.editSessionService.unregisterEditSession(this.activeEditSessionNoteId);
      this.activeEditSessionNoteId = null;
    }
    if (this.autosaveDebounceTimer) {
      clearTimeout(this.autosaveDebounceTimer);
      this.autosaveDebounceTimer = null;
    }
    if (this.autosaveMaxTimer) {
      clearTimeout(this.autosaveMaxTimer);
      this.autosaveMaxTimer = null;
    }
    this.routeParamSub?.unsubscribe();
    this.destroy$.next();
    this.destroy$.complete();
  }

  private registerCurrentEditSession(): void {
    const noteId = (this.noteId || '').trim();
    if (!noteId) {
      return;
    }

    this.editSessionService.registerEditSession(noteId, {
      route: `/edit/${encodeURIComponent(noteId)}`,
      title: this.note?.Title || undefined,
    });
    this.activeEditSessionNoteId = noteId;
  }

  // ##############################################################################
  // PRESENTATION LAYER / GUI ROUTINES (CALL-BACK ETC.)
  // ##############################################################################

  get f() {
    return this.editNoteForm.controls;
  }

  get isEventType(): boolean {
    const value = this.editNoteForm?.get('NoteType')?.value;
    return String(value || '').trim().toLowerCase() === 'event';
  }

  get noteSizeLabel(): string {
    return formatPersistedNoteSize(this.note?.Size);
  }

  get attachmentCount(): number {
    const attachments = this.note?.Attachments;
    return Array.isArray(attachments) ? attachments.length : 0;
  }

  get tagCount(): number {
    return Array.isArray(this.noteTags) ? this.noteTags.length : 0;
  }

  toggleMetadataMore(): void {
    this.isMetadataMoreVisible = !this.isMetadataMoreVisible;
  }

  isLoading(): boolean {
    return this.loadingCounter > 0;
  }

  pageMenu(item: string): void {
    const actions: { [key: string]: () => void } = {
      Close: () => void this.forceSaveThenClose(true),
      Delete: () => this.deleteItem(),
      DownloadPDF: () => {
        // this.clickFood();
      },
      Home: () => void this.forceSaveThenClose(true),
      New: () => {
        this.clickNew();
        this.navigateHome();
      },
      Print: () => {
        //this.printOrExportNote("print");
      },
      CreateCopy: () => this.createCopyOfNote(),
      SaveAsTemplate: () => this.openSaveTemplateDialog(),
      SaveNote: () => this.saveNote(false),
      SaveNoteAndClose: () => this.saveNote(true),
      SaveNoteAndView: () => this.saveNoteAndView(),
      UserSettings: () => this.router.navigate(['user-settings']),
      FindSimilar: () => this.findSimilarNotes(),
      View: () => void this.forceSaveThenView(),
    };

    const action = actions[item];
    if (action) {
      action();
    } else {
      console.warn(`Unknown menu item: ${item}`);
    }
  }

  findSimilarNotes(): void {
    const noteId = this.note?._id;
    if (!noteId) {
      return;
    }
    this.similarNotesResults = [];
    this.similarNotesError = '';
    this.similarNotesLoading = true;
    this.similarNotesDialogVisible = true;

    this.data_service.findSimilarNotes(noteId).subscribe({
      next: (resp) => {
        this.similarNotesLoading = false;
        const raw: unknown = resp?.data;
        if (Array.isArray(raw)) {
          this.similarNotesResults = raw as SimilarNoteResult[];
        } else if (raw && typeof raw === 'object' && Array.isArray((raw as any)['results'])) {
          this.similarNotesResults = (raw as any)['results'] as SimilarNoteResult[];
        } else {
          this.similarNotesResults = [];
        }
      },
      error: (err) => {
        this.similarNotesLoading = false;
        this.similarNotesError =
          err?.error?.error || err?.error?.message || err?.message || 'Failed to find similar notes.';
      },
    });
  }


  getSimilarNoteId(note: SimilarNoteResult): string {
    return String(note._id ?? note.id ?? '');
  }

  formatSimilarNoteDate(note: SimilarNoteResult): string {
    const raw = note.updated_at ?? note.modified_at ?? note.modifiedDate ?? note.last_modified ?? '';
    if (!raw) {
      return '-';
    }
    try {
      return new Date(String(raw)).toLocaleDateString('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
      });
    } catch {
      return String(raw);
    }
  }

  openSaveTemplateDialog(): void {
    this.templateName = this.note?.Title ?? '';
    this.templateNameTouched = false;
    this.saveTemplateDialogVisible = true;
  }

  saveTemplateFromDialog(): void {
    this.templateNameTouched = true;

    const trimmedName = this.templateName.trim();
    if (!trimmedName || !this.note || this.isSavingTemplate) {
      return;
    }

    this.isSavingTemplate = true;
    this.applyChangesToNoteFromForm();

    this.data_service.createTemplateFromNote(this.note, trimmedName).subscribe(
      (resp) => {
        if (resp.status === 'success') {
          this.snackbarService.showSuccessMessage('Template saved successfully.');
          this.saveTemplateDialogVisible = false;
          // Refresh template cache for instant access
          this.data_service.refreshTemplateCache();
        } else {
          this.snackbarService.showErrorMessage('Failed to save template.');
        }
        this.isSavingTemplate = false;
      },
      (err) => {
        console.error('Error saving template:', err);
        this.snackbarService.showErrorMessage('Failed to save template.');
        this.isSavingTemplate = false;
      },
    );
  }

  toggleMobileMenu() {
    this.MobileMenuIsVisible = !this.MobileMenuIsVisible;
  }

  onOtherContentChanged(event: any) {
    if (this.isLoading() == true) return;
    // Update note.Title to reflect changes in the title bar
    if (this.editNoteForm.controls['Title']) {
      this.note.Title = this.editNoteForm.controls['Title'].value;
    }
    this.markContentChanged();
  }

  onEditorDeltaContentUpdated(editor: string, event: any) {
    if (this.isLoading() == true) return;
    this.markContentChanged();
  }

  onEditorHtmlContentUpdated(field: 'Description' | 'Comments', html: string) {
    // console.log('[Edit] onEditorHtmlContentUpdated called for', field, 'length:', html.length);
    if (this.isLoading()) return;
    //   console.log(`HTML content updated for ${field}:`, html);
    if (field === 'Description') {
      // console.log('[Edit] Patching DescriptionHtml form value');
      this.editNoteForm.patchValue({ DescriptionHtml: html }, { emitEvent: false });
    } else if (field === 'Comments') {
      this.editNoteForm.patchValue({ CommentsHtml: html }, { emitEvent: false });
    }

    this.markContentChanged();
  }

  onCategoryChange(event: any) {
    console.log('onCategoryChange: ', event);
    this.selectedCategoryIDs = event;
    this.markContentChanged();
    this.isCategoriesChanged = true;
    //console.log("contents updated!!");
    //this.note!.Category = event.ID;
  }

  onDropdownSelectionChange(MenuName: string, value: any): void {
    // console.log('in onFilterSelectionChange()');
    if (MenuName === 'Category') {
      console.log('NEW Category Selected :', value);
    }
  }

  setTitle(newTitle: string) {
    this.titleService.setTitle(newTitle);
  }

  updateStatusMessage() {
    this.statusMessage = '';
    if (this.isContentChanged) {
      this.statusMessage = 'Unsaved ';
    }
  }

  private markContentChanged(): void {
    this.setContentChanged(true);
    this.contentChangeCounter++;
    // Must run after the counter increments above — canDiscardSinceOpening
    // compares against it, and syncDiscardMenuItemState() inside
    // setContentChanged() would otherwise read the pre-increment value.
    this.syncDiscardMenuItemState();
    if (this.autosaveEnabled) {
      this.autosaveState = 'unsaved';
      this.scheduleAutosave();
    }
  }

  private setContentChanged(isContentChanged: boolean): void {
    this.isContentChanged = isContentChanged;
    this.unsavedChangesState.setHasUnsavedChanges(isContentChanged);
    this.updateStatusMessage();
  }

  // ##############################################################################
  // AUTOSAVE (Stage 1 — local-first, debounced, cancel-safe)
  // ##############################################################################

  /** Resets the 5s idle debounce; starts (but does not reset) the 25s max-interval timer. */
  private scheduleAutosave(): void {
    if (!this.autosaveEnabled) return;

    if (this.autosaveDebounceTimer) {
      clearTimeout(this.autosaveDebounceTimer);
    }
    this.autosaveDebounceTimer = setTimeout(() => {
      this.autosaveDebounceTimer = null;
      void this.performAutosave('debounce');
    }, EditComponent.AUTOSAVE_DEBOUNCE_MS);

    if (!this.autosaveMaxTimer) {
      this.autosaveMaxTimer = setTimeout(() => {
        this.autosaveMaxTimer = null;
        void this.performAutosave('max-interval');
      }, EditComponent.AUTOSAVE_MAX_INTERVAL_MS);
    }
  }

  /**
   * Local-first autosave: builds the note from the current form/editor state
   * and writes it straight to IndexedDB (marking it dirty for the existing
   * background sync cycle), skipping validation, attachment upload, dialogs
   * and any remote round-trip — those stay on the explicit Save path and on
   * the "leaving the editor" force-saves (View/Close), which flush attachments
   * via forceAutosaveIfDirty() before calling this.
   *
   * Serialized: only one autosave runs at a time. If new edits arrive while
   * one is in flight, another run is queued immediately after it finishes.
   *
   * `notify` surfaces user-visible feedback (a success toast, or an error
   * dialog on failure) — used only for the explicit Ctrl+S/Cmd+S shortcut, so
   * regular debounce/max-interval/backgrounding autosaves stay silent.
   */
  private async performAutosave(reason: string, notify: boolean = false): Promise<void> {
    if (this.autosaveDebounceTimer) {
      clearTimeout(this.autosaveDebounceTimer);
      this.autosaveDebounceTimer = null;
    }
    if (this.autosaveMaxTimer) {
      clearTimeout(this.autosaveMaxTimer);
      this.autosaveMaxTimer = null;
    }

    if (!this.autosaveEnabled || !this.note || !this.editNoteForm) return;

    if (this.autosaveInFlight) {
      this.autosavePendingRerun = true;
      if (notify) {
        this.alertService.success('Changes saved successfully!', { life: 4000 });
      }
      return;
    }

    if (this.contentChangeCounter === this.autosaveLastSavedGeneration) {
      // Nothing new since the last local save — the note is already saved,
      // so a manual Ctrl+S still gets its confirmation.
      if (notify) {
        this.alertService.success('Changes saved successfully!', { life: 4000 });
      }
      return;
    }

    this.autosaveInFlight = true;
    this.autosaveState = 'saving-local';
    const generation = this.contentChangeCounter;
    this.applyChangesToNoteFromForm();

    try {
      await this.data_service.autosaveNote(this.note);
      this.temporaryStatus = false;
      this.autosaveLastSavedGeneration = generation;
      void this.touchOpeningSnapshotActivity();

      // Only clear the dirty flag if nothing changed while we were saving —
      // otherwise a newer edit would be silently marked "saved".
      if (this.contentChangeCounter === generation) {
        this.setContentChanged(false);
      }

      this.autosaveState = this.note.syncStatus === 'synced' ? 'saved' : this.isOnline ? 'syncing' : 'saved-local';
      this.watchForSyncCompletion();

      // The periodic sync timer already gets reset to its 30s floor whenever a
      // note is marked dirty (SyncCoordinator listens for that itself), but
      // that still means waiting up to 30s for the next tick. Nudge an
      // incremental sync now so autosave's "syncing" state resolves in
      // roughly a second instead — this reuses the exact same push/pull
      // cycle the periodic timer would have run, it's just triggered early;
      // forceIncrementalSync() already de-dupes against a cycle already in
      // flight, so this can't race the periodic timer or pile up calls.
      if (this.isOnline) {
        void this.syncCoordinator.forceIncrementalSync('auto');
      }

      if (notify) {
        this.alertService.success('Changes saved successfully!', { life: 4000 });
      }
    } catch (err: any) {
      console.error(`[Autosave] local save failed (reason=${reason})`, err);
      this.autosaveState = 'unsaved';
      if (notify) {
        const msg = err?.message || 'Error saving note.';
        this.gDS.showGlobalDialog('Save Failed', 'Could not save note', msg, DialogType.Error);
      }
    } finally {
      this.autosaveInFlight = false;
      if (this.autosavePendingRerun) {
        this.autosavePendingRerun = false;
        void this.performAutosave('rerun-after-inflight');
      } else if (this.contentChangeCounter !== generation) {
        this.scheduleAutosave();
      }
    }
  }

  /** Immediately flushes any pending debounced edit — used for Ctrl+S, View, Close, and backgrounding.
   * Also uploads any pending attachment additions/renames/deletions first: the debounced/max-interval
   * autosave ticks deliberately skip attachment upload (see performAutosave()), so this is the only
   * place that does it in autosave mode — without it, attachments added via drag-and-drop would never
   * reach the server since the explicit Save buttons are hidden while autosave is enabled. */
  private async forceAutosaveIfDirty(reason: string): Promise<void> {
    if (!this.autosaveEnabled) return;

    const hasPendingAttachments = this.hasPendingAttachmentChanges();
    if (!this.isContentChanged && !hasPendingAttachments) return;

    if (hasPendingAttachments) {
      const uploadError = await this.flushPendingAttachments();
      if (uploadError) {
        this.gDS.showGlobalDialog('Save Failed', 'Could not save attachments', uploadError, DialogType.Error);
      } else {
        // Attachments changed but form fields may not have — force performAutosave()
        // past its "nothing new since last save" guard so the updated Attachments
        // array actually gets persisted to IndexedDB and queued for sync.
        this.markContentChanged();
      }
    }

    await this.performAutosave(reason);
  }

  /**
   * Once a note has been locally autosaved, watch the existing SyncCoordinator
   * push cycle for this note's syncStatus to flip to 'synced' so the footer
   * can move from "syncing"/"saved-local" to "saved" (or "sync-failed" if a
   * push cycle completed while online and the note is still dirty).
   */
  private watchForSyncCompletion(): void {
    if (this.autosaveSyncSub) return;

    this.autosaveSyncSub = this.syncCoordinator
      .onSyncCompleted()
      .pipe(takeUntil(this.destroy$))
      .subscribe(async () => {
        const noteId = this.note?._id;
        if (!noteId) return;

        const result = await firstValueFrom(this.data_service.getNote(noteId));
        const freshStatus = result.status === 'success' ? result.data?.syncStatus : undefined;

        if (freshStatus === 'synced') {
          // SyncCoordinator pushes/refreshes IndexedDB from its own note
          // reference, not this.note, so the _rev it got back from the
          // server never otherwise reaches the object autosave keeps
          // mutating. Without this, the next autosave writes this.note's
          // stale _rev straight back into IndexedDB, and the following push
          // hits a 409 (harmless — the remote client already retries with
          // the latest rev — but it's a wasted round-trip and console noise
          // on every single edit after the first).
          if (this.note && result.data) {
            if (result.data._rev) this.note._rev = result.data._rev;
            if ((result.data as any).remote_rev) (this.note as any).remote_rev = (result.data as any).remote_rev;
          }
          if (this.contentChangeCounter === this.autosaveLastSavedGeneration) {
            this.autosaveState = 'saved';
          }
          this.autosaveSyncSub?.unsubscribe();
          this.autosaveSyncSub = undefined;
        } else if (this.contentChangeCounter === this.autosaveLastSavedGeneration) {
          // Still dirty after a full sync cycle: only report failure while
          // online (offline just means sync hasn't had a chance to run yet).
          this.autosaveState = this.isOnline ? 'sync-failed' : 'saved-local';
        }
      });
  }

  /** Icon/label/animation for the footer autosave status indicator. */
  get autosaveStatusView(): { icon: string; label: string; colorClass: string; spin: boolean } {
    switch (this.autosaveState) {
      case 'unsaved':
        return { icon: 'edit', label: 'Unsaved edits', colorClass: 'autosave-status--unsaved', spin: false };
      case 'saving-local':
        return { icon: 'save', label: 'Saving…', colorClass: 'autosave-status--saving', spin: false };
      case 'saved-local':
        return { icon: 'cloud_queue', label: 'Saved locally · awaiting sync', colorClass: 'autosave-status--queued', spin: false };
      case 'syncing':
        return { icon: 'sync', label: 'Synchronizing…', colorClass: 'autosave-status--syncing', spin: true };
      case 'sync-failed':
        return { icon: 'cloud_off', label: 'Sync failed · saved locally', colorClass: 'autosave-status--failed', spin: false };
      case 'saved':
      default:
        return { icon: 'cloud_done', label: 'Saved', colorClass: 'autosave-status--saved', spin: false };
    }
  }

  @HostListener('document:visibilitychange')
  onVisibilityChangeAutosave(): void {
    if (document.visibilityState === 'hidden') {
      void this.forceAutosaveIfDirty('visibilitychange');
    }
  }

  @HostListener('window:pagehide')
  onPageHideAutosave(): void {
    void this.forceAutosaveIfDirty('pagehide');
  }

  /** Force-save (if autosave is on) then navigate home. No-op save when autosave is off — identical to prior behavior.
   * This is the Close SplitButton's main action: force-save locally, queue
   * synchronization (both already covered by forceAutosaveIfDirty), delete
   * the session snapshot, and close — the record lock itself is released
   * separately in ngOnDestroy()/route-change teardown, same as before. */
  private async forceSaveThenClose(clearHistory: boolean): Promise<void> {
    await this.forceAutosaveIfDirty('close');
    await this.deleteOpeningSnapshotIfAny();
    if (clearHistory) {
      this.navigationService.clearHistory();
    }
    this.navigateHome();
  }

  /** Force-save (if autosave is on) then navigate to the View page. No-op save when autosave is off — identical to prior behavior. */
  private async forceSaveThenView(): Promise<void> {
    await this.forceAutosaveIfDirty('view');
    this.router.navigate(['view', this.note?._id], {
      state: {
        filter: this.filter,
        homeState: this.homeState,
      },
    });
  }

  // ##############################################################################
  // AUTOSAVE (Stage 2 — opening snapshot & discard)
  // ##############################################################################

  /** Snapshots this note's editable content as it stands right when this
   * edit session opens (before any edits are possible), so "Discard changes
   * since opening…" can restore it later. IndexedDB-only; never synced to
   * the backend, and doesn't duplicate attachment binaries. */
  private async createOpeningSnapshot(): Promise<void> {
    if (!this.note?._id) return;
    const sessionRecord = this.editSessionService.getSessionRecord(this.note._id);
    if (!sessionRecord) return;

    const nowIso = new Date().toISOString();
    const snapshot: NoteEditSessionSnapshot = {
      noteId: this.note._id,
      sessionId: sessionRecord.sessionId,
      openedAt: sessionRecord.openedAt,
      lastActiveAt: nowIso,
      openingRev: this.note._rev,
      instanceId: this.editSessionService.getTabId(),
      status: 'active',
      lockRef: sessionRecord.sessionId,
      content: this.currentSnapshotContent(),
    };

    try {
      await this.data_service.saveEditSessionSnapshot(snapshot);
      this.openingSnapshot = snapshot;
    } catch (err) {
      console.error('[Autosave] Failed to create opening snapshot', err);
    } finally {
      this.syncDiscardMenuItemState();
    }
  }

  /** Refreshes the opening snapshot's lastActiveAt on every successful
   * autosave, so Stage 3's startup abandonment check (which classifies a
   * session as abandoned once lastActiveAt is old enough) never mistakes an
   * ordinary reload mid-way through a long, still-actively-autosaving
   * session for an abandoned one. */
  private async touchOpeningSnapshotActivity(): Promise<void> {
    if (!this.openingSnapshot || !this.note?._id) return;
    this.openingSnapshot.lastActiveAt = new Date().toISOString();
    try {
      await this.data_service.saveEditSessionSnapshot(this.openingSnapshot);
    } catch (err) {
      console.error('[Autosave] Failed to refresh opening snapshot activity', err);
    }
  }

  /** The editable-content subset of this.note, in the same shape stored in
   * (and restored from) an opening snapshot. */
  private currentSnapshotContent(): NoteEditSessionSnapshotContent {
    return extractSnapshotContent(this.note);
  }

  /** True once anything has changed since the opening snapshot was taken.
   * Reuses the same monotonic edit-generation counter Stage 1 already uses
   * for stale-save protection instead of deep-diffing content on every
   * check — cheap, and exactly tracks "has markContentChanged() fired
   * since the snapshot was captured." */
  get canDiscardSinceOpening(): boolean {
    return (
      this.autosaveEnabled &&
      !!this.openingSnapshot &&
      this.contentChangeCounter !== this.openingSnapshotBaselineCounter
    );
  }

  /** Opens the "Discard changes since opening…" confirmation. `viaClose`
   * distinguishes the Close-SplitButton dropdown from the page-menu item,
   * since "Keep changes"/"Discard changes" continue editing or close
   * afterward depending on which one triggered the dialog. */
  openDiscardChangesDialog(viaClose: boolean): void {
    if (!this.canDiscardSinceOpening) return;
    this.discardInvokedViaClose = viaClose;
    this.confirmationService.confirm({
      header: 'Discard editing changes?',
      message:
        'This restores the note to how it was when you opened the editor. Changes made during this editing session will be removed.',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Discard changes',
      rejectLabel: 'Keep changes',
      acceptButtonStyleClass: 'p-button-danger',
      accept: () => void this.onDiscardChangesConfirmed(),
      reject: () => void this.onKeepChangesFromDiscardDialog(),
    });
  }

  private async onKeepChangesFromDiscardDialog(): Promise<void> {
    const viaClose = this.discardInvokedViaClose;
    this.discardInvokedViaClose = false;
    if (viaClose) {
      await this.forceSaveThenClose(true);
    } else {
      await this.forceAutosaveIfDirty('keep-changes-dialog');
    }
  }

  private async onDiscardChangesConfirmed(): Promise<void> {
    const viaClose = this.discardInvokedViaClose;
    this.discardInvokedViaClose = false;
    await this.restoreOpeningSnapshot();
    if (viaClose) {
      await this.forceSaveThenClose(true);
    }
  }

  /** Restores this.note, the reactive form, and tag/related-note UI state to
   * the opening snapshot's content, then immediately persists that as a new
   * dirty update. Per spec this must NOT roll back synchronization or
   * version history — it creates a new restoring update on top, same as any
   * other autosave. */
  private async restoreOpeningSnapshot(): Promise<void> {
    if (!this.openingSnapshot || !this.note || !this.editNoteForm) return;
    const c = this.openingSnapshot.content;

    this.note.Title = c.Title;
    this.note.DescriptionHtml = c.DescriptionHtml;
    this.note.DescriptionDelta = c.DescriptionDelta;
    this.note.CommentsHtml = c.CommentsHtml;
    this.note.CommentsDelta = c.CommentsDelta;
    this.note.Keywords = c.Keywords;
    (this.note as any).AiKeywords = c.AiKeywords;
    this.note.Status = c.Status;
    this.note.NoteType = c.NoteType;
    this.note.Confidential = c.Confidential;
    this.note.ReferenceDate = c.ReferenceDate;
    this.note.StartDate = c.StartDate;
    this.note.EndDate = c.EndDate;
    this.note.Categories = [...c.Categories];
    this.note.Tags = [...c.Tags];
    this.note.RelatedNotes = [...c.RelatedNotes];

    this.noteTags = this.resolveNoteTags(this.note, this.availableTags);
    this.relatedNotes = getOrderedRelatedNoteIds(c.RelatedNotes);
    this.refreshRelatedNoteObjects();

    const nodeIndex = this.buildNodeIndex(this.categories_tree);
    const selectedNodes = this.note.Categories.map((id) => nodeIndex.get(id)).filter((n): n is TreeNode => !!n);
    this.editNoteForm.patchValue({
      Title: c.Title,
      DescriptionHtml: c.DescriptionHtml,
      DescriptionDelta: c.DescriptionDelta,
      CommentsHtml: c.CommentsHtml,
      CommentsDelta: c.CommentsDelta,
      Keywords: c.Keywords,
      AiKeywords: c.AiKeywords,
      Status: c.Status,
      NoteType: c.NoteType,
      Confidential: c.Confidential,
      ReferenceDate: c.ReferenceDate,
      StartDate: c.StartDate,
      EndDate: c.EndDate,
      Categories: selectedNodes,
    });
    this.cdRef.detectChanges();

    this.markContentChanged();
    this.openingSnapshotBaselineCounter = this.contentChangeCounter;
    this.syncDiscardMenuItemState();
    await this.performAutosave('discard-restore');
  }

  private async deleteOpeningSnapshotIfAny(): Promise<void> {
    if (!this.openingSnapshot || !this.note?._id) return;
    const sessionId = this.openingSnapshot.sessionId;
    this.openingSnapshot = null;
    try {
      await this.data_service.deleteEditSessionSnapshot(this.note._id, sessionId);
    } catch (err) {
      console.error('[Autosave] Failed to delete opening snapshot', err);
    }
  }

  @HostListener('window:beforeunload', ['$event'])
  onBeforeUnload(event: BeforeUnloadEvent): void {
    if (!this.isContentChanged) {
      return;
    }

    event.preventDefault();
    event.returnValue = true;
  }

  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    if (this.isContentChanged) {
      return new Promise<boolean>((resolve) => {
        this.deactivateResolver = resolve;
        this.unsavedChangesDialogVisible = true;
      });
    }
    return true;
  }

  onConfirmDiscard(): void {
    this.unsavedChangesDialogVisible = false;
    if (this.pendingCancelEdits) {
      this.pendingCancelEdits = false;
      this.completeCancelEdits();
    } else if (this.deactivateResolver) {
      this.deactivateResolver(true);
      this.deactivateResolver = null;
    }
  }

  onCancelDiscard(): void {
    this.unsavedChangesDialogVisible = false;
    if (this.deactivateResolver) {
      this.deactivateResolver(false);
      this.deactivateResolver = null;
    }
  }

  onClose() {
    void this.forceSaveThenClose(false);
  }

  private navigateHome(refresh = false): void {
    RichEditorComponent.clearPersistedCollapsibleStateForNote(this.note?._id ?? this.noteId);

    const state: any = {
      filter: this.filter,
      homeState: this.homeState,
    };
    if (refresh) {
      state.refresh = true;
    }
    this.router.navigate(['/home'], { state });
  }

  toggleHeaderFields(): void {
    console.log('toggle header fields now =', !this.isHeaderVisible);
    this.isHeaderVisible = !this.isHeaderVisible;
  }

  toggleDescription(): void {
    this.isDescriptionExpanded = !this.isDescriptionExpanded;
  }

  toggleAllCollapsibleSections(): void {
    if (!this.descriptionEditor?.editor) {
      console.warn('Description editor not available');
      return;
    }

    const newState = !this.areAllCollapsibleExpanded;
    this.areAllCollapsibleExpanded = newState;

    // Call the editor's method to toggle all sections
    this.descriptionEditor.toggleAllCollapsibleSections(newState);
  }

  toggleFileAttachments(): void {
    this.isFileAttachmentsExpanded = !this.isFileAttachmentsExpanded;
  }

  toggleTags(): void {
    this.isTagsExpanded = !this.isTagsExpanded;
  }

  openTagManager(): void {
    this.router.navigate(['/edit-tags']);
  }

  toggleKeywords(): void {
    this.isKeywordsExpanded = !this.isKeywordsExpanded;
  }

  toggleComments(): void {
    this.isCommentsExpanded = !this.isCommentsExpanded;
  }

  toggleFavorite(): void {
    const noteId = this.note?._id;
    if (!noteId) {
      this.snackbarService.showErrorMessage('No note selected.');
      return;
    }
    const previous = [...this.favoriteNoteIds];
    const isCurrentlyFavorite = this.favoriteNoteIds.includes(noteId);
    const updated = isCurrentlyFavorite
      ? this.favoriteNoteIds.filter((id) => id !== noteId)
      : [...this.favoriteNoteIds, noteId];

    this.favoriteNoteIds = updated;
    this.isFavorite = !isCurrentlyFavorite;
    this.userSettings.setLocal({ favoriteNoteIds: updated });

    this.userSettings.updateFavorites(updated).subscribe({
      next: () => {
        const message = isCurrentlyFavorite ? 'Removed from favorites' : 'Added to favorites';
        this.snackbarService.showSuccessMessage(message);
      },
      error: (err) => {
        console.warn('Failed to update favorite status', err);
        this.favoriteNoteIds = previous;
        this.updateFavoriteState();
        this.userSettings.setLocal({ favoriteNoteIds: previous });
        this.snackbarService.showErrorMessage('Failed to update favorites.');
      },
    });
  }

  private updateFavoriteState(): void {
    const noteId = this.note?._id;
    if (!noteId) {
      this.isFavorite = false;
      return;
    }
    this.isFavorite = this.favoriteNoteIds.includes(noteId);
  }

  private normalizeFavoriteNoteIds(value: unknown): string[] {
    if (!Array.isArray(value)) {
      return [];
    }
    return value.filter((id) => typeof id === 'string');
  }

  clickNew(): void {
    console.log('clickNew');
    this.createNewNote();
  }

  setSelectedCategoryItems(selectedCategoryIDs: string[]): void {
    /**
     * Set the isSelected property of each item in the categoryItems list based on the selectedCategoryIDs.
     *
     * @param selectedCategoryIDs - List of selected category IDs.
     */
    console.log('in setSelectedCategoryItems(). selectedCategoryIDs = ', selectedCategoryIDs);
    this.categoryItems.forEach((item) => {
      console.log('item.ID = ', item._id, ' selected-categories = ', this.note?.Categories);
      item.isSelected = this.note?.Categories.includes(item._id);
    });
  }

  @HostListener('window:keydown', ['$event'])
  handleKeyDown(event: KeyboardEvent): void {
    const isModKeyPressed = event.ctrlKey || event.metaKey;
    const pressedKey = (event.key || '').toLowerCase();
    const isSaveCombo = isModKeyPressed && (pressedKey === 's' || event.code === 'KeyS');

    if (isSaveCombo) {
      event.preventDefault();
      void this.handleSaveShortcut();
    }
  }

  async handleSaveShortcut(): Promise<void> {
    if (this.isSaving) {
      return;
    }
    if (this.autosaveEnabled) {
      // Ctrl+S in autosave mode is an immediate forced *local* save, not the
      // full validated Save (which also uploads attachments and round-trips
      // to the server) — that stays reserved for View/Close. It's still an
      // explicit user action though, so — unlike the silent debounce/
      // max-interval/backgrounding autosaves — it gets a toast on success
      // (or an error dialog on failure) via performAutosave's notify flag.
      await this.performAutosave('shortcut-forced', true);
      return;
    }
    await this.saveNote(false);
  }

  clearTitle() {
    //const titleField = this.TitleField.nativeElement;
    this.note!.Title = '';
    //titleField.focus();
  }

  // ##############################################################################
  // SAVING & DELETING DATA
  // ##############################################################################
  createNewNote(): void {
    console.log('🟢 In createNewNote()');

    this.data_service.createNote().subscribe(
      (response) => {
        if (response.status === 'success' && response.data) {
          const newNote = response.data;
          console.log('✅ New temporary note created:', newNote._id);

          this.router.navigate(['/edit', newNote._id], {
            state: {
              filter: this.filter,
              homeState: this.homeState,
            },
          });

          this.alertService.success('New note created successfully.', {
            keepAfterRouteChange: false,
            life: 3000,
          });
        } else {
          console.error('⚠️ Failed to create note');
          this.alertService.warn('Failed to create note.', {
            keepAfterRouteChange: false,
            life: 4000,
          });
        }
      },
      (err) => {
        console.error('❌ Unexpected error in createNewNote():', err);
        this.alertService.error(`An unexpected error occurred while creating the note.`, {
          keepAfterRouteChange: false,
          life: 5000,
        });
      },
    );
  }

  createCopyOfNote(): void {
    if (!this.note) {
      this.snackbarService.showErrorMessage('Note is not available to copy.');
      return;
    }

    this.loadingCounter++;

    this.data_service.createNoteCopy(this.note).subscribe({
      next: (response: any) => {
        if (response.status === 'success' && response.data) {
          const newNote = response.data;
          console.log('✅ Copied note created locally:', newNote._id);

          this.router.navigate(['/edit', newNote._id], {
            state: {
              filter: this.filter,
              homeState: this.homeState,
            },
          });
        } else {
          const msg = response.error?.message || 'Failed to create note copy.';
          console.warn('⚠️ createCopyOfNote():', msg);
          this.alertService?.warn?.(msg, { life: 4000 });
        }

        this.loadingCounter--;
      },

      error: (err) => {
        console.error('❌ createCopyOfNote(): unexpected error:', err);
        this.alertService?.error?.('An unexpected error occurred while creating a note copy.', { life: 5000 });
        this.loadingCounter--;
      },
    });
  }

  //   createNewNote(): void {
  //     console.log('in createNewNote()');
  //     this.data_service.new_note().subscribe(
  //       (response: any) => {
  //         const newNoteResponse = response as NewNoteResponse;
  //         console.log('Status: ', newNoteResponse);
  //         this.router.navigate(['/edit', newNoteResponse.id], {
  //           state: { filter: this.filter },
  //         });
  //       },
  //       (error) => {
  //         console.error('Error fetching new note:', error);
  //         // Handle any errors here
  //       },
  //     );
  //   }

  applyChangesToNoteFromForm(): void {
    if (!this.note || !this.editNoteForm) return;
    const v = this.editNoteForm.value;

    this.note.Title = v.Title;
    this.note.DescriptionDelta = v.DescriptionDelta;
    this.note.DescriptionHtml = v.DescriptionHtml;
    this.note.Keywords = v.Keywords;
    (this.note as any).AiKeywords = v.AiKeywords;
    this.note.Tags = this.noteTags.map((tag) => tag._id);
    this.note.RelatedNotes = toRelatedNotesPayload(this.relatedNotes);
    this.note.CommentsDelta = v.CommentsDelta;
    this.note.CommentsHtml = v.CommentsHtml;
    this.note.ReferenceDate = v.ReferenceDate ? new Date(v.ReferenceDate).toISOString() : this.note.created_on;
    this.note.StartDate = v.StartDate ? new Date(v.StartDate).toISOString() : undefined;
    this.note.EndDate = v.EndDate ? new Date(v.EndDate).toISOString() : undefined;
    this.note.Confidential = !!v.Confidential;
    this.note.Status = v.Status;
    const noteType = v.NoteType ?? this.note.NoteType ?? 'To Do';
    this.note.NoteType = typeof noteType === 'string' ? noteType.trim() : noteType;
    if (this.note.type !== 'note' && this.note.type !== 'template') {
      this.note.type = 'note';
    }
    if (!this.note.Project || this.note.Project === 0) {
      this.note.Project = 16;
      this.note.ProjectName = 'Obsolete_Field';
    }

    const sel = v.Categories || [];
    const selectedCategoryIds = sel
      .map((n: any) => (typeof n === 'string' ? n : n?.key))
      .filter((k: any): k is string => !!k);

    this.note.Categories = selectedCategoryIds.length > 0
      ? selectedCategoryIds
      : [this.unsortedCategoryId];

    if (selectedCategoryIds.length === 0) {
      this.editNoteForm.patchValue({ Categories: [this.unsortedCategoryId] }, { emitEvent: false });
    }

    // ... your existing project lookup, etc.
  }

  async addQuickTag(): Promise<void> {
    if (typeof this.quickTagName !== 'string') {
      const didAssociate = this.associateTag(this.quickTagName);
      this.resetQuickTagInput();
      if (didAssociate) {
        this.markContentChanged();
      }
      return;
    }

    const value = this.quickTagInputText.trim();
    if (!value) {
      return;
    }

    const slug = this.slugify(value);
    const existingNoteTag = this.noteTags.find((tag) => tag.slug === slug);
    if (existingNoteTag) {
      this.resetQuickTagInput();
      this.alertService.warn(`Tag "${value}" already exists.`);
      return;
    }

    const existingCatalogTag = this.availableTags.find((tag) => tag.slug === slug || tag.name.toLowerCase() === value.toLowerCase());
    if (existingCatalogTag) {
      const didAssociate = this.associateTag(existingCatalogTag);
      this.resetQuickTagInput();
      if (didAssociate) {
        this.markContentChanged();
      }
      return;
    }

    const payload = this.buildTagPayload({
      name: value,
      tagType: this.defaultTagType,
      slug,
      color: '#2563EB',
      icon: 'tag',
      sortOrder: this.getNextTagSortOrder(),
      isActive: true,
    });

    this.isTagMutating = true;
    try {
      const resp = await firstValueFrom(this.data_service.createTag(payload));
      if (resp.status !== 'success' || !resp.data) {
        this.alertService.error(resp.error?.message || 'Failed to create tag.');
        return;
      }

      this.upsertAvailableTag(resp.data);
      const didAssociate = this.associateTag(resp.data);
      this.resetQuickTagInput();
      if (didAssociate) {
        this.markContentChanged();
      }
      this.alertService.success(`Tag "${resp.data.name}" created.`);
    } catch (err: any) {
      this.alertService.error(err?.message || 'Failed to create tag.');
    } finally {
      this.isTagMutating = false;
    }
  }

  openCreateTagDialog(): void {
    const nextSortOrder = this.getNextTagSortOrder();
    this.editingTagIndex = null;
    this.tagDraftId = '';
    this.tagDraftRev = undefined;
    this.tagDraftName = this.quickTagInputText.trim();
    this.tagDraftType = this.defaultTagType;
    this.tagDraftSlug = this.slugify(this.tagDraftName);
    this.tagDraftColor = '#2563EB';
    this.tagDraftIcon = '';
    this.tagDraftParentTagId = '';
    this.tagDraftParentTag = '';
    this.tagDraftSortOrder = nextSortOrder;
    this.tagDraftIsActive = true;
    this.tagDialogVisible = true;
  }

  openEditTagDialog(tag: Tag, index: number): void {
    this.editingTagIndex = index;
    this.tagDraftId = tag._id;
    this.tagDraftRev = tag._rev;
    this.tagDraftName = tag.name;
    this.tagDraftType = this.normalizeTagType(tag.tagType);
    this.tagDraftSlug = tag.slug;
    this.tagDraftColor = tag.color ?? '#2563EB';
    this.tagDraftIcon = tag.icon ?? '';
    this.tagDraftParentTagId = tag.parentTagId ?? '';
    this.tagDraftParentTag = this.availableTags.find((availableTag) => availableTag._id === tag.parentTagId) ?? '';
    this.tagDraftSortOrder = tag.sortOrder ?? (index + 1) * 10;
    this.tagDraftIsActive = tag.isActive;
    this.tagDialogVisible = true;
  }

  async saveTagDialog(): Promise<void> {
    const name = this.tagDraftName.trim();
    if (!name) {
      this.alertService.warn('Tag name is required.');
      return;
    }

    const slug = this.slugify(this.tagDraftSlug || name);
    const duplicate = this.noteTags.findIndex((tag, idx) => idx !== this.editingTagIndex && tag.slug === slug);
    if (duplicate >= 0) {
      this.alertService.warn('Another tag already uses this slug.');
      return;
    }

    const fallbackSortOrder = this.editingTagIndex !== null ? (this.editingTagIndex + 1) * 10 : this.getNextTagSortOrder();
    const payload = this.buildTagPayload({
      name,
      tagType: this.normalizeTagType(this.tagDraftType),
      slug,
      color: this.tagDraftColor?.trim() || '#2563EB',
      icon: this.tagDraftIcon.trim() || 'tag',
      parentTagId: this.tagDraftParentTagId,
      sortOrder: Number.isFinite(this.tagDraftSortOrder) ? Number(this.tagDraftSortOrder) : fallbackSortOrder,
      isActive: this.tagDraftIsActive,
    });

    const existingServerTag = this.availableTags.find((tag) => tag._id === this.tagDraftId);

    this.isTagMutating = true;
    try {
      const resp = existingServerTag
        ? await firstValueFrom(this.data_service.updateTag(existingServerTag._id, payload))
        : await firstValueFrom(this.data_service.createTag(payload));

      if (resp.status !== 'success' || !resp.data) {
        this.alertService.error(resp.error?.message || 'Failed to save tag.');
        return;
      }

      this.upsertAvailableTag(resp.data);
      this.replaceAssociatedTag(resp.data, this.editingTagIndex);
      this.markContentChanged();
      this.tagDialogVisible = false;
      this.resetQuickTagInput();
      this.alertService.success(existingServerTag ? 'Tag updated.' : 'Tag created.');
    } catch (err: any) {
      this.alertService.error(err?.message || 'Failed to save tag.');
    } finally {
      this.isTagMutating = false;
    }
  }

  detachTagAt(index: number): void {
    if (index < 0 || index >= this.noteTags.length) {
      return;
    }
    this.noteTags = this.noteTags.filter((_, idx) => idx !== index);
    this.syncTagsToForm();
    this.markContentChanged();
  }

  async deleteTagAt(index: number): Promise<void> {
    if (index < 0 || index >= this.noteTags.length) {
      return;
    }

    const tag = this.noteTags[index];
    this.isTagMutating = true;
    try {
      const resp = await firstValueFrom(this.data_service.deleteTag(tag._id));
      if (resp.status !== 'success') {
        this.alertService.error(resp.error?.message || 'Failed to delete tag.');
        return;
      }

      this.noteTags = this.noteTags.filter((_, idx) => idx !== index);
      this.availableTags = this.availableTags.filter((availableTag) => availableTag._id !== tag._id);
      this.syncTagsToForm();
      this.filteredTagSuggestions = this.filteredTagSuggestions.filter((suggestedTag) => suggestedTag._id !== tag._id);
      this.markContentChanged();
      this.tagDialogVisible = false;
      this.alertService.success(`Tag "${tag.name}" deleted.`);
    } catch (err: any) {
      this.alertService.error(err?.message || 'Failed to delete tag.');
    } finally {
      this.isTagMutating = false;
    }
  }

  onTagNameDraftChanged(): void {
    this.tagDraftSlug = this.slugify(this.tagDraftName);
  }

  searchTagSuggestions(event: any): void {
    this.refreshTagSuggestions(event?.query);
  }

  onTagAutocompleteSelected(event: any): void {
    const tag = event?.value as Tag | undefined;
    if (!tag) {
      return;
    }

    const didAssociate = this.associateTag(tag);
    this.resetQuickTagInput();
    if (didAssociate) {
      this.markContentChanged();
    }
  }

  showAvailableTagSuggestions(): void {
    this.refreshTagSuggestions();
  }

  searchParentTagSuggestions(event: any): void {
    const query = String(event?.query ?? '').trim().toLowerCase();
    const currentTagId = this.tagDraftId;

    this.filteredParentTagSuggestions = this.sortTagsByOrder(
      this.availableTags.filter((tag) => {
        if (currentTagId && tag._id === currentTagId) {
          return false;
        }

        if (!query) {
          return true;
        }

        return [tag.name, tag.slug, tag.tagType, tag.icon ?? '']
          .some((value) => value.toLowerCase().includes(query));
      }),
    );
  }

  onParentTagSelected(event: any): void {
    const tag = event?.value as Tag | undefined;
    this.tagDraftParentTagId = tag?._id ?? '';
  }

  onParentTagInputChanged(value: string | Tag): void {
    if (typeof value === 'string') {
      const normalized = value.trim().toLowerCase();
      const match = this.availableTags.find(
        (tag) => tag._id !== this.tagDraftId && (tag.name.toLowerCase() === normalized || tag.slug === this.slugify(value)),
      );
      this.tagDraftParentTagId = match?._id ?? '';
      return;
    }

    this.tagDraftParentTagId = value?._id ?? '';
  }

  clearParentTag(): void {
    this.tagDraftParentTag = '';
    this.tagDraftParentTagId = '';
    this.filteredParentTagSuggestions = [];
  }

  get quickTagInputText(): string {
    if (typeof this.quickTagName === 'string') {
      return this.quickTagName;
    }
    return this.quickTagName?.name ?? '';
  }

  get parentTagInputText(): string {
    if (typeof this.tagDraftParentTag === 'string') {
      return this.tagDraftParentTag;
    }
    return this.tagDraftParentTag?.name ?? '';
  }

  getTagChipLabel(tag: Tag): string {
    return `${tag.name} · ${tag.tagType}${tag.isActive ? '' : ' · inactive'}`;
  }

  getTagChipStyle(tag: Tag): Record<string, string> {
    const borderColor = tag.color || '#94a3b8';
    return tag.isActive
      ? { borderColor, backgroundColor: `${borderColor}14`, color: '#0f172a' }
      : { borderColor: '#9ca3af', backgroundColor: '#f3f4f6', color: '#6b7280', opacity: '0.85' };
  }

  getTagStatusLabel(tag: Tag): string {
    return tag.isActive ? 'Active' : 'Inactive';
  }

  private syncTagsToForm(): void {
    this.editNoteForm?.patchValue(
      {
        Tags: this.noteTags.map((tag) => tag._id),
      },
      { emitEvent: false },
    );
  }

  /** Refreshes the tag catalog from the server after the note has already
   * rendered from cache, so opening a note never blocks on a live tags fetch. */
  private async refreshTagCatalogInBackground(): Promise<void> {
    try {
      const tagsResp = await firstValueFrom(this.data_service.getAllTags());
      if (tagsResp.status === 'success' && tagsResp.data) {
        this.availableTags = this.sortTagsByOrder(tagsResp.data);
        if (this.note) {
          this.noteTags = this.resolveNoteTags(this.note, this.availableTags);
        }
        this.cdRef.markForCheck();
      }
    } catch (err) {
      console.warn('Failed to refresh tag catalog:', err);
    }
  }

  private sortTagsByOrder(tags: Tag[]): Tag[] {
    return [...tags].sort((a, b) => {
      const orderA = a.sortOrder ?? Number.MAX_SAFE_INTEGER;
      const orderB = b.sortOrder ?? Number.MAX_SAFE_INTEGER;
      if (orderA !== orderB) return orderA - orderB;
      return a.name.localeCompare(b.name);
    });
  }

  private getNextTagSortOrder(): number {
    const maxSortOrder = this.noteTags.reduce((max, tag) => Math.max(max, tag.sortOrder ?? 0), 0);
    return maxSortOrder + 10;
  }

  private resolveNoteTags(note: Note, availableTags: Tag[]): Tag[] {
    const rawTags = (note as any)?.Tags;
    if (!Array.isArray(rawTags)) {
      return [];
    }

    const normalized = rawTags
      .map((rawTag: any, index: number) => {
        if (typeof rawTag === 'string') {
          const trimmed = rawTag.trim();
          if (!trimmed) return null;
          const existingById = availableTags.find((tag) => tag._id === trimmed);
          if (existingById) {
            return existingById;
          }

          // Already-issued tag id (`tag:<slug>:<uuid>`) that just isn't in
          // the currently-loaded tag cache yet (e.g. tag catalog still
          // syncing, or this tag was deleted). Preserve the id as-is rather
          // than slugifying the whole id string into a brand new tag - doing
          // that used to fabricate a garbled id/name (visible as the raw id
          // string in the UI) and, because Tags gets re-serialized from
          // noteTags on every save, permanently overwrote the real
          // reference with that garbage on the very next save. If the
          // catalog finishes loading afterwards, resolveNoteTags runs again
          // and resolves this to the real tag since the id was never lost.
          if (trimmed.startsWith('tag:')) {
            return {
              _id: trimmed,
              type: 'tag',
              name: '(unresolved tag)',
              tagType: this.defaultTagType,
              slug: this.slugify(trimmed),
              color: '#94a3b8',
              icon: 'tag',
              parentTagId: null,
              sortOrder: (index + 1) * 10,
              isActive: true,
            } as Tag;
          }

          const slug = this.slugify(trimmed);
          const existingTag = availableTags.find((tag) => tag.slug === slug || tag.name.toLowerCase() === trimmed.toLowerCase());
          if (existingTag) {
            return existingTag;
          }
          return {
            _id: this.generateTagId(slug),
            type: 'tag',
            name: trimmed,
            tagType: this.defaultTagType,
            slug,
            color: '#2563EB',
            icon: 'tag',
            parentTagId: null,
            sortOrder: (index + 1) * 10,
            isActive: true,
          } as Tag;
        }

        const name = String(rawTag?.name ?? '').trim();
        if (!name) {
          return null;
        }

        const slug = this.slugify(rawTag?.slug ?? name);
        const existingTag = availableTags.find((tag) => tag._id === String(rawTag?._id ?? '') || tag.slug === slug);
        if (existingTag) {
          return existingTag;
        }

        return {
          _id: String(rawTag?._id ?? this.generateTagId(slug)),
          _rev: rawTag?._rev ? String(rawTag._rev) : undefined,
          type: 'tag',
          name,
          tagType: this.normalizeTagType(rawTag?.tagType),
          slug,
          color: rawTag?.color ? String(rawTag.color) : '#2563EB',
          icon: rawTag?.icon ? String(rawTag.icon) : 'tag',
          parentTagId: rawTag?.parentTagId ? String(rawTag.parentTagId) : null,
          sortOrder: Number.isFinite(rawTag?.sortOrder) ? Number(rawTag.sortOrder) : (index + 1) * 10,
          isActive: rawTag?.isActive !== false,
        } as Tag;
      })
      .filter((tag): tag is Tag => !!tag);

    return this.sortTagsByOrder(normalized);
  }

  private associateTag(tag: Tag): boolean {
    if (this.noteTags.some((noteTag) => noteTag._id === tag._id || noteTag.slug === tag.slug)) {
      return false;
    }
    this.noteTags = this.sortTagsByOrder([...this.noteTags, tag]);
    this.syncTagsToForm();
    return true;
  }

  private replaceAssociatedTag(tag: Tag, index: number | null): void {
    if (index === null || index < 0 || index >= this.noteTags.length) {
      this.associateTag(tag);
      return;
    }

    const nextTags = [...this.noteTags];
    nextTags[index] = tag;
    this.noteTags = this.sortTagsByOrder(nextTags);
    this.syncTagsToForm();
  }

  private upsertAvailableTag(tag: Tag): void {
    const index = this.availableTags.findIndex((existingTag) => existingTag._id === tag._id);
    if (index === -1) {
      this.availableTags = this.sortTagsByOrder([...this.availableTags, tag]);
      return;
    }

    const nextTags = [...this.availableTags];
    nextTags[index] = tag;
    this.availableTags = this.sortTagsByOrder(nextTags);
  }

  private buildTagPayload(tag: Partial<Tag>): TagMutationPayload {
    return {
      name: String(tag.name ?? '').trim(),
      tagType: this.normalizeTagType(tag.tagType),
      slug: this.slugify(String(tag.slug ?? tag.name ?? '')),
      color: tag.color?.trim() || '#2563EB',
      icon: tag.icon?.trim() || 'tag',
      parentTagId: typeof tag.parentTagId === 'string' && tag.parentTagId.trim() ? tag.parentTagId.trim() : null,
      sortOrder: typeof tag.sortOrder === 'number' ? tag.sortOrder : this.getNextTagSortOrder(),
      isActive: tag.isActive !== false,
    };
  }

  private normalizeTagType(value: unknown): string {
    const normalized = String(value ?? '').trim().toLowerCase();
    return this.tagTypeOptions.includes(normalized) ? normalized : this.defaultTagType;
  }

  private refreshTagSuggestions(query: unknown = ''): void {
    const normalizedQuery = String(query ?? '').trim().toLowerCase();
    const selectedTagIds = new Set(this.noteTags.map((tag) => tag._id));

    this.filteredTagSuggestions = this.sortTagsByOrder(
      this.availableTags.filter((tag) => {
        if (selectedTagIds.has(tag._id)) {
          return false;
        }

        if (!normalizedQuery) {
          return true;
        }

        return [tag.name, tag.slug, tag.tagType, tag.icon ?? '']
          .some((value) => value.toLowerCase().includes(normalizedQuery));
      }),
    );
  }

  private resetQuickTagInput(): void {
    this.quickTagName = '';
    this.refreshTagSuggestions();
  }

  private slugify(value: string): string {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/(^-|-$)/g, '');
  }

  private generateTagId(slug: string): string {
    const randomPart = globalThis.crypto?.randomUUID?.() ?? `${Date.now()}${Math.floor(Math.random() * 100000)}`;
    return `tag:${slug || 'item'}:${randomPart}`;
  }

  validateNote(): boolean {
    if (this.note) {
      if (!this.note.Title || this.note.Title.trim() === '') {
        const errorMsg = 'Title field must not be empty!';
        this.snackbarService.showErrorMessage(errorMsg);
        return false;
      }
      if (!this.note.NoteType || this.note.NoteType.trim() === '') {
        const errorMsg = 'Note Type must not be empty!';
        this.snackbarService.showErrorMessage(errorMsg);
        return false;
      }
      // Add more validation rules as needed
      return true;
    } else {
      const errorMsg = 'No note loaded to validate!';
      this.snackbarService.showErrorMessage(errorMsg);
      return false;
    }
  }

  private showOfflineSaveWarning(onDismiss?: () => void): void {
    this.confirmationService.confirm({
      header: 'Offline Save',
      message: 'You are offline. This note was saved locally and will sync when connection is restored.',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'OK',
      rejectVisible: false,
      closable: false,
      closeOnEscape: false,
      dismissableMask: false,
      blockScroll: true,
      accept: () => {
        if (onDismiss) {
          onDismiss();
        }
      },
    });
  }

  private showLocalSaveWarning(message: string, onDismiss?: () => void): void {
    this.confirmationService.confirm({
      header: 'Saved Locally',
      message,
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'OK',
      rejectVisible: false,
      closable: false,
      closeOnEscape: false,
      dismissableMask: false,
      blockScroll: true,
      accept: () => {
        if (onDismiss) {
          onDismiss();
        }
      },
    });
  }

  private waitForNextPaint(): Promise<void> {
    return new Promise((resolve) => {
      requestAnimationFrame(() => resolve());
    });
  }

  /** True if the file-upload panel (when mounted) has additions, renames, or
   * deletions that haven't been sent to the server yet. */
  private hasPendingAttachmentChanges(): boolean {
    const entries = this.fileUploadComponent?.fileEntries;
    if (!entries) return false;
    return entries.some((e) => e.status === 'new' || e.status === 'renamed' || e.status === 'deleted');
  }

  /** Uploads/renames/deletes attachments via the mounted file-upload panel and
   * merges the results into this.note.Attachments. Returns an error message
   * on failure, or null on success (including when there was nothing to do,
   * e.g. the attachments panel was never expanded). */
  private async flushPendingAttachments(): Promise<string | null> {
    const fileUploadResult = this.fileUploadComponent
      ? await firstValueFrom(this.fileUploadComponent.saveChanges())
      : { status: 'success' as const, data: { AttachmentsAdded: [], AttachmentsDeleted: [] } };

    if (fileUploadResult.status !== 'success') {
      return 'error' in fileUploadResult && fileUploadResult.error?.message
        ? fileUploadResult.error.message
        : 'Error during attachment upload.';
    }

    const addedIds = fileUploadResult.data?.AttachmentsAdded ?? [];
    const deletedIds = fileUploadResult.data?.AttachmentsDeleted ?? [];

    if (!Array.isArray(this.note.Attachments)) {
      this.note.Attachments = [];
    }

    for (const id of addedIds) {
      if (!this.note.Attachments.includes(id)) {
        this.note.Attachments.push(id);
      }
    }

    this.note.Attachments = this.note.Attachments.filter((id) => !deletedIds.includes(id));

    return null;
  }

  async saveNote(closeForm: boolean): Promise<boolean> {
    if (this.isSaving) return false;
    this.applyChangesToNoteFromForm();
    if (!this.validateNote()) return false;

    this.isSaving = true;
    const saveChangeCounter = this.contentChangeCounter;
    await this.waitForNextPaint();

    try {
      // 1️⃣ Upload attachments
      const uploadError = await this.flushPendingAttachments();
      if (uploadError) {
        this.gDS.showGlobalDialog('Save Failed', 'Could not save note', uploadError, DialogType.Error);
        return false;
      }

      // 2️⃣ SAVE NOTE — FIXED
      const noteSaveResult = await firstValueFrom(this.data_service.updateNote(this.note));

      this.temporaryStatus = false;

      if (noteSaveResult.status === 'success') {
        if (noteSaveResult.data) {
          this.note = { ...this.note, ...noteSaveResult.data };
        }

        // Persist the _rev returned by the server so subsequent saves use the
        // update path (PUT) instead of retrying a create (POST → 409 conflict).
        if (noteSaveResult.data?._rev && !this.note._rev) {
          (this.note as any)._rev = noteSaveResult.data._rev;
        }

        this.alertService.success('Changes saved successfully!', {
          keepAfterRouteChange: true,
          life: 4000,
        });

        if (saveChangeCounter === this.contentChangeCounter) {
          this.editNoteForm.markAsPristine();
          this.setContentChanged(false);
          this.tempMessage = 'Saved successfully!';
        }

        if (closeForm) {
          this.navigationService.clearHistory();
          this.navigateHome(true);
        }

        return true;
      }

      if (noteSaveResult.status === 'warning') {
        const msg = noteSaveResult.error?.message || 'Saved locally. Remote sync is pending.';
        this.tempMessage = msg;
        this.editNoteForm.markAsPristine();
        this.setContentChanged(false);
        this.unsavedChangesDialogVisible = false;
        this.pendingCancelEdits = false;

        if (closeForm) {
          const onDismiss = () => {
            this.navigationService.clearHistory();
            this.navigateHome(true);
          };
          if (this.isOnline) {
            this.showLocalSaveWarning(msg, onDismiss);
          } else if (!this.offlineSaveDialogShown) {
            this.offlineSaveDialogShown = true;
            this.showOfflineSaveWarning(onDismiss);
          } else {
            this.alertService.warn('Note saved locally. Will sync when connection is restored.', { life: 5000 });
            onDismiss();
          }
        } else {
          if (this.isOnline) {
            this.showLocalSaveWarning(msg);
          } else if (!this.offlineSaveDialogShown) {
            this.offlineSaveDialogShown = true;
            this.showOfflineSaveWarning();
          } else {
            this.alertService.warn('Note saved locally. Will sync when connection is restored.', { life: 5000 });
          }
        }

        return true;
      }

      let msg = noteSaveResult.error?.message || 'An error occurred while saving the note.';
      // If error details, warnings, or excluded fields are present, show them
      if (noteSaveResult.error) {
        const err = noteSaveResult.error;
        if ((err as any).details) {
          msg += `\nDetails: ${JSON.stringify((err as any).details, null, 2)}`;
        }
        if ((err as any).warnings) {
          msg += `\nWarnings: ${JSON.stringify((err as any).warnings, null, 2)}`;
        }
        if ((err as any).excluded_fields) {
          msg += `\nExcluded fields: ${JSON.stringify((err as any).excluded_fields, null, 2)}`;
        }
      }
      this.gDS.showGlobalDialog('Save Failed', 'Could not save note', msg, DialogType.Error);
      return false;
    } catch (err: any) {
      console.error('❌ Error during saveNote:', err);
      const msg = err?.message || 'Error saving note.';
      this.gDS.showGlobalDialog('Save Failed', 'Could not save note', msg, DialogType.Error);
      return false;
    } finally {
      this.isSaving = false;
    }
  }

  private async saveNoteAndView(): Promise<void> {
    if (this.isSaving) {
      return;
    }

    this.applyChangesToNoteFromForm();
    if (!this.validateNote()) {
      return;
    }

    this.isSaving = true;
    const saveChangeCounter = this.contentChangeCounter;
    await this.waitForNextPaint();

    try {
      const uploadError = await this.flushPendingAttachments();
      if (uploadError) {
        this.gDS.showGlobalDialog('Save Failed', 'Could not save note', uploadError, DialogType.Error);
        return;
      }

      const noteSaveResult = await firstValueFrom(this.data_service.updateNote(this.note));

      this.temporaryStatus = false;

      if (noteSaveResult.status === 'success') {
        if (noteSaveResult.data) {
          this.note = { ...this.note, ...noteSaveResult.data };
        }

        if (noteSaveResult.data?._rev && !this.note._rev) {
          (this.note as any)._rev = noteSaveResult.data._rev;
        }

        this.alertService.success('Changes saved successfully!', {
          keepAfterRouteChange: true,
          life: 4000,
        });

        if (saveChangeCounter === this.contentChangeCounter) {
          this.editNoteForm.markAsPristine();
          this.setContentChanged(false);
          this.tempMessage = 'Saved successfully!';
        }

        this.router.navigate(['view', this.note?._id], {
          state: {
            filter: this.filter,
            homeState: this.homeState,
            note: this.note,
          },
        });
        return;
      }

      if (noteSaveResult.status === 'warning') {
        const msg = noteSaveResult.error?.message || 'Saved locally. Remote sync is pending.';
        this.tempMessage = msg;
        this.editNoteForm.markAsPristine();
        this.setContentChanged(false);
        this.unsavedChangesDialogVisible = false;
        this.pendingCancelEdits = false;

        const onDismiss = () => {
          this.router.navigate(['view', this.note?._id], {
            state: {
              filter: this.filter,
              homeState: this.homeState,
              note: this.note,
            },
          });
        };

        if (this.isOnline) {
          this.showLocalSaveWarning(msg, onDismiss);
        } else if (!this.offlineSaveDialogShown) {
          this.offlineSaveDialogShown = true;
          this.showOfflineSaveWarning(onDismiss);
        } else {
          this.alertService.warn('Note saved locally. Will sync when connection is restored.', { life: 5000 });
          onDismiss();
        }
        return;
      }

      const msg = noteSaveResult.error?.message || 'An error occurred while saving the note.';
      this.gDS.showGlobalDialog('Save Failed', 'Could not save note', msg, DialogType.Error);
    } catch (err: any) {
      console.error('❌ Error during saveNoteAndView:', err);
      const msg = err?.message || 'Error saving note.';
      this.gDS.showGlobalDialog('Save Failed', 'Could not save note', msg, DialogType.Error);
    } finally {
      this.isSaving = false;
    }
  }

  cancelEdits() {
    if (this.autosaveEnabled) {
      // Autosave keeps IndexedDB continuously up to date, so "Close" here
      // just needs to flush any still-debounced edit, not offer a discard
      // dialog — Stage 1 has no discard mechanism (that's autosave Stage 2).
      void this.forceSaveThenClose(true);
      return;
    }
    if (this.isContentChanged) {
      this.pendingCancelEdits = true;
      this.unsavedChangesDialogVisible = true;
      return;
    }
    this.completeCancelEdits();
  }

  private completeCancelEdits() {
    if (this.temporaryStatus == true) {
      if (this.note) {
        this.data_service.deleteNote(this.note).subscribe(
          // OBSOLETE Couch-DB specific version -- should delete locally only
          () => {
            console.log('HTTP DELETE Response:', Response);
            this.tempMessage = 'Deleted successfully!';
            this.snackbarService.showSuccessMessage('Successfully deleted temporary note!');
            this.navigationService.clearHistory();
            this.navigateHome();
          },
          (error) => {
            console.error('HTTP DELETE Error:', error);
            this.tempMessage = error.error.message || 'An error occurred while deleting the temporary note.';
            this.snackbarService.showErrorMessage(this.tempMessage);
          },
        );
      }
    }
    this.setContentChanged(false);
    this.navigationService.clearHistory();
    this.navigateHome();
  }

  deleteItem() {
    if (!this.note) return;
    
    this.confirmationService.confirm({
      header: 'Delete Note',
      message: `Are you sure you want to delete "${this.note.Title || 'this note'}"?`,
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Delete',
      rejectLabel: 'Cancel',
      acceptButtonStyleClass: 'p-button-danger',
      accept: () => {
        console.log('Deleting note: ', this.note);
        this.data_service.deleteNote(this.note).subscribe(
          () => {
            console.log('HTTP DELETE Response:', Response);
            this.tempMessage = 'Deleted successfully!';
            this.snackbarService.showSuccessMessage('Successfully deleted note!');
            this.navigationService.clearHistory();
            // Refresh template cache in case a template was deleted
            this.data_service.refreshTemplateCache();
            this.navigateHome(true);
          },
          (error) => {
            console.error('HTTP DELETE Error:', error);
            this.tempMessage = 'An error occurred while deleting the note: ' + error.error.message;
            this.snackbarService.showErrorMessage(this.tempMessage);
          },
        );
      }
    });
  }

  async generateKeywords(): Promise<void> {
    console.log('in generateKeywords():');

    if (this.aiKeywordsLoading) {
      return;
    }
    this.aiKeywordsLoading = true;
    try {
      const formValue = this.editNoteForm.value;
      const categories: string[] = (formValue.Categories || [])
        .map((c: any) => {
          if (typeof c === 'string') return c;
          if (c?.key) return c.key;
          if (c?._id) return c._id;
          return '';
        })
        .filter((c: string) => !!c);

      const payload = {
        title: formValue.Title ?? '',
        description: this.stripHtmlToText(formValue.DescriptionHtml ?? this.note?.DescriptionHtml ?? ''),
        comments: this.stripHtmlToText(formValue.CommentsHtml ?? this.note?.CommentsHtml ?? ''),
        categories,
      };

      console.log('AI keyword payload:', payload);

      const resp = await firstValueFrom(this.data_service.generateKeywords(payload));
      if (resp.status === 'success') {
        const keywords = resp.data?.keywords ?? [];
        const keywordString = Array.isArray(keywords) ? keywords.join(', ') : '';
        this.editNoteForm.patchValue({ AiKeywords: keywordString });
        (this.note as any).AiKeywords = keywordString;
        this.alertService.success('AI keywords generated.');
      } else {
        const msg = resp.error?.message || 'Keyword generation failed.';
        this.alertService.warn(msg);
      }
    } catch (err: any) {
      const msg =
        err?.error?.error?.message || err?.error?.message || err?.message || 'Keyword generation request failed.';
      this.alertService.error(msg);
      console.error('Automatic keywords error:', err);
    } finally {
      this.aiKeywordsLoading = false;
    }
  }

  async generateSuggestedTags(): Promise<void> {
    if (this.aiSuggestTagsLoading) {
      return;
    }

    const noteId = this.note?._id;
    if (!noteId) {
      this.alertService.warn('Save this note before generating AI tag suggestions.');
      return;
    }

    this.aiSuggestTagsLoading = true;
    this.aiSuggestTagsDialogVisible = false;
    this.aiSuggestedTags = [];

    try {
      const payload = { note_id: noteId };

      const resp = await firstValueFrom(this.data_service.suggestTags(payload));
      if (resp.status !== 'success') {
        this.alertService.warn(resp.error?.message || 'AI tag suggestion failed.');
        return;
      }

      const suggestedTags = Array.isArray(resp.data?.suggested_tags) ? resp.data!.suggested_tags : [];
      this.aiSuggestedTags = suggestedTags.map((tag) => ({
        _id: String(tag._id ?? ''),
        name: String(tag.name ?? ''),
        description: String(tag.Description ?? ''),
        selected: true,
      })).filter((tag) => !!tag._id && !!tag.name);

      this.aiSuggestTagsDialogVisible = true;
      if (this.aiSuggestedTags.length === 0) {
        this.alertService.warn('No fitting tags were suggested for this note.');
      }
    } catch (err: any) {
      const msg = err?.error?.error?.message || err?.error?.message || err?.message || 'AI tag suggestion request failed.';
      this.alertService.error(msg);
      console.error('AI suggest tags error:', err);
    } finally {
      this.aiSuggestTagsLoading = false;
    }
  }

  cancelSuggestedTagsDialog(): void {
    this.aiSuggestTagsDialogVisible = false;
    this.aiSuggestedTags = [];
  }

  addSelectedSuggestedTags(): void {
    const selected = this.aiSuggestedTags.filter((tag) => tag.selected);
    if (selected.length === 0) {
      this.alertService.warn('No tags selected.');
      return;
    }

    let addedCount = 0;
    for (const suggested of selected) {
      const resolvedTag = this.mapSuggestedTagToTag(suggested);
      if (this.associateTag(resolvedTag)) {
        addedCount += 1;
      }
    }

    this.aiSuggestTagsDialogVisible = false;
    this.aiSuggestedTags = [];

    if (addedCount > 0) {
      this.markContentChanged();
      this.alertService.success(`${addedCount} tag${addedCount === 1 ? '' : 's'} added.`);
      return;
    }

    this.alertService.warn('Selected tags are already assigned to this note.');
  }

  get hasSelectedSuggestedTags(): boolean {
    return this.aiSuggestedTags.some((tag) => tag.selected);
  }

  // ---------------------------------------------------------------
  // Related Notes
  // ---------------------------------------------------------------

  toggleRelatedNotes(): void {
    this.isRelatedNotesExpanded = !this.isRelatedNotesExpanded;
  }

  /** Moves the related note at `index` one position up (-1) or down (+1). */
  moveRelatedNote(index: number, direction: -1 | 1): void {
    const targetIndex = index + direction;
    if (index < 0 || index >= this.relatedNotes.length || targetIndex < 0 || targetIndex >= this.relatedNotes.length) {
      return;
    }

    const reordered = [...this.relatedNotes];
    [reordered[index], reordered[targetIndex]] = [reordered[targetIndex], reordered[index]];
    this.relatedNotes = reordered;
    this.refreshRelatedNoteObjects();
    this.markContentChanged();
  }

  onNoteLinkInserted(noteId: string): void {
    if (!noteId || this.relatedNotes.includes(noteId)) {
      return;
    }
    this.relatedNotes = [...this.relatedNotes, noteId];
    this.refreshRelatedNoteObjects();
    this.markContentChanged();
  }

  openAddRelatedNoteDialog(): void {
    this.relatedNoteSearchQuery = '';
    this.relatedNoteSearchResults = [];
    this.addRelatedNoteCreateBacklink = true;
    this.addRelatedNoteDialogVisible = true;
  }

  onRelatedNoteSearch(): void {
    const q = this.relatedNoteSearchQuery.trim().toLowerCase();
    if (!q) {
      this.relatedNoteSearchResults = [];
      return;
    }
    this.relatedNoteSearchResults = this.data_service.allNotes
      .filter(
        (n) =>
          n._id !== this.note?._id &&
          (n.Title?.toLowerCase().includes(q) || n._id.toLowerCase().includes(q))
      )
      .slice(0, 25);
  }

  async selectRelatedNote(n: Note): Promise<void> {
    const id = n._id;
    if (!id) return;
    if (this.relatedNotes.includes(id)) {
      this.alertService.warn('This note is already linked.');
      return;
    }
    const createBacklink = this.addRelatedNoteCreateBacklink;
    const sourceId = this.note?._id;

    this.relatedNotes = [...this.relatedNotes, id];
    this.refreshRelatedNoteObjects();
    this.markContentChanged();
    this.addRelatedNoteDialogVisible = false;
    this.relatedNoteSearchQuery = '';
    this.relatedNoteSearchResults = [];

    if (createBacklink && sourceId) {
      await this.createBacklinksForSelectedNotes([id], sourceId);
    }
  }

  logRelatedNoteTrashClick(index: number): void {
    console.log('[RelatedNotes] native (click) fired on trash button, index=', index);
  }

  requestRemoveRelatedNote(index: number): void {
    console.log('[RelatedNotes] requestRemoveRelatedNote() called, index=', index);
    const ref = this.relatedNoteObjects[index];
    if (!ref) {
      console.log('[RelatedNotes] requestRemoveRelatedNote() aborted: no ref at index', index, this.relatedNoteObjects);
      return;
    }

    const targetNote = this.data_service.allNotes.find((n) => n._id === ref.id);
    const targetRelated = getOrderedRelatedNoteIds((targetNote as any)?.RelatedNotes);
    const hasBacklink = !!this.note?._id && targetRelated.includes(this.note._id);

    this.removeRelatedNotePendingIndex = index;
    this.removeRelatedNotePendingId = ref.id;
    this.removeRelatedNotePendingTitle = ref.title || '(Untitled)';
    this.removeRelatedNoteHasBacklink = hasBacklink;
    this.removeRelatedNoteDeleteBacklink = hasBacklink;
    this.removeRelatedNoteDialogVisible = true;
    console.log('[RelatedNotes] removeRelatedNoteDialogVisible set to true for', ref.id, ref.title);
  }

  async confirmRemoveRelatedNote(): Promise<void> {
    console.log('[RelatedNotes] confirmRemoveRelatedNote() called, pendingIndex=', this.removeRelatedNotePendingIndex, 'pendingId=', this.removeRelatedNotePendingId);
    this.removeRelatedNoteDialogVisible = false;

    const index = this.removeRelatedNotePendingIndex;
    const removedId = this.removeRelatedNotePendingId;
    const removedTitle = this.removeRelatedNotePendingTitle || '(Untitled)';
    const deleteBacklink = this.removeRelatedNoteDeleteBacklink && this.removeRelatedNoteHasBacklink;

    if (!this.note?._id || index < 0 || index >= this.relatedNotes.length) {
      console.log('[RelatedNotes] confirmRemoveRelatedNote() aborted early: note?._id=', this.note?._id, 'index=', index, 'relatedNotes.length=', this.relatedNotes.length);
      return;
    }

    const updatedRelatedNotes = this.relatedNotes.filter((_, i) => i !== index);

    try {
      // Persist the link removal on the CURRENT note immediately, rather than
      // deferring it to the next time the user clicks the main Save button.
      const updatedCurrentNote: Note = { ...this.note, RelatedNotes: toRelatedNotesPayload(updatedRelatedNotes) };
      const result = await firstValueFrom(this.data_service.updateNote(updatedCurrentNote));
      if (result.status === 'error') {
        throw new Error(result.error?.message || 'Failed to update note.');
      }

      // Reflect the server/IndexedDB-confirmed note and give visual confirmation
      // by removing the row from the Related Notes section.
      this.note = result.data ?? updatedCurrentNote;
      this.relatedNotes = updatedRelatedNotes;
      this.refreshRelatedNoteObjects();

      if (deleteBacklink && removedId) {
        try {
          const otherResult = await firstValueFrom(this.data_service.getNote(removedId));
          if (otherResult.status === 'success' && otherResult.data) {
            const otherNote = otherResult.data;
            const otherRelatedIds = getOrderedRelatedNoteIds((otherNote as any).RelatedNotes);

            if (otherRelatedIds.includes(this.note._id)) {
              const backlinkResult = await firstValueFrom(
                this.data_service.updateNote({
                  ...otherNote,
                  RelatedNotes: toRelatedNotesPayload(otherRelatedIds.filter((id) => id !== this.note!._id)),
                }),
              );
              if (backlinkResult.status === 'error') {
                throw new Error(backlinkResult.error?.message || 'Failed to remove backlink.');
              }
            }
          }
        } catch (backlinkErr: any) {
          // The primary link removal already succeeded; surface the backlink
          // failure on its own rather than rolling back the successful part.
          this.alertService.warn(
            `Removed "${removedTitle}" from Related Notes, but could not remove the backlink on the other note: ${backlinkErr?.message ?? backlinkErr}`,
          );
          return;
        }
      }

      this.alertService.success(`Removed "${removedTitle}" from Related Notes.`);
    } catch (err: any) {
      this.alertService.error(`Failed to remove "${removedTitle}" from Related Notes: ${err?.message ?? err}`);
    }
  }

  openFindSimilarForLink(): void {
    const noteId = this.note?._id;
    if (!noteId) {
      this.alertService.warn('Save the note first to find similar notes.');
      return;
    }
    this.similarForLinkResults = [];
    this.similarForLinkError = '';
    this.createBacklinksChecked = true;
    this.similarForLinkLoading = true;
    this.similarForLinkDialogVisible = true;

    this.data_service.findSimilarNotes(noteId).subscribe({
      next: (res) => {
        const raw = res?.data;
        const results: SimilarNoteResult[] = Array.isArray(raw)
          ? raw
          : Array.isArray((raw as any)?.results)
            ? (raw as any).results
            : [];
        if (results.length > 0) {
          console.log('[FindSimilar] first result keys:', Object.keys(results[0]));
          console.log('[FindSimilar] first result:', JSON.stringify(results[0]));
        }
        this.similarForLinkResults = results.map((r) => {
          const id = String(r._id ?? r.id ?? '');
          const localNote = id ? this.data_service.allNotes.find((n) => n._id === id) : undefined;
          return {
            ...r,
            Status: localNote?.Status ?? (r.Status as string | undefined),
            selected: false,
          };
        });
        this.similarForLinkLoading = false;
      },
      error: (err) => {
        console.error('Similar notes error:', err);
        this.similarForLinkError = 'Failed to load similar notes.';
        this.similarForLinkLoading = false;
      },
    });
  }

  async linkSelectedSimilarNotes(): Promise<void> {
    const selected = this.similarForLinkResults.filter((r) => r.selected);
    if (selected.length === 0) {
      this.alertService.warn('No notes selected.');
      return;
    }

    const backlinksRequested = this.createBacklinksChecked;
    const newlyLinkedIds: string[] = [];

    for (const item of selected) {
      const id = String(item._id ?? item.id ?? '');
      if (!id) continue;
      if (this.relatedNotes.includes(id)) continue;
      this.relatedNotes = [...this.relatedNotes, id];
      newlyLinkedIds.push(id);
    }

    if (newlyLinkedIds.length > 0) {
      this.refreshRelatedNoteObjects();
      this.markContentChanged();
      this.alertService.success(`${newlyLinkedIds.length} note${newlyLinkedIds.length === 1 ? '' : 's'} linked.`);
    } else {
      this.alertService.warn('Selected notes are already linked.');
    }

    this.similarForLinkDialogVisible = false;
    this.similarForLinkResults = [];

    if (backlinksRequested && this.note?._id && newlyLinkedIds.length > 0) {
      await this.createBacklinksForSelectedNotes(newlyLinkedIds, this.note._id);
    }
  }

  private async createBacklinksForSelectedNotes(targetIds: string[], sourceId: string): Promise<void> {
    for (const targetId of targetIds) {
      try {
        const otherNote = await this.fetchNoteById(targetId);
        if (!otherNote) continue;

        const otherRelatedIds = getOrderedRelatedNoteIds((otherNote as any).RelatedNotes);

        if (otherRelatedIds.includes(sourceId)) continue;

        await firstValueFrom(
          this.data_service.updateNote({
            ...otherNote,
            RelatedNotes: toRelatedNotesPayload([...otherRelatedIds, sourceId]),
          })
        );
      } catch (err) {
        console.warn(`[createBacklinks] Failed to create backlink in ${targetId}:`, err);
      }
    }
  }

  private async fetchNoteById(noteId: string): Promise<Note | undefined> {
    try {
      const response = await firstValueFrom(this.data_service.getNote(noteId));
      const note = response?.data;
      return note && typeof note === 'object' ? note : undefined;
    } catch (error) {
      console.error('Failed to load note for backlink creation:', noteId, error);
      return undefined;
    }
  }

  get hasSelectedSimilarForLink(): boolean {
    return this.similarForLinkResults.some((r) => r.selected);
  }

  getSimilarForLinkNoteId(item: SimilarNoteSelectionItem): string {
    return String(item._id ?? item.id ?? '');
  }

  formatSimilarForLinkDate(item: SimilarNoteSelectionItem): string {
    const raw = String(item.updated_at ?? item.modified_at ?? item.last_modified ?? item.modifiedDate ?? '');
    if (!raw) return '-';

    const d = new Date(raw);
    return isNaN(d.getTime())
      ? raw
      : d.toLocaleDateString(undefined, {
          day: '2-digit',
          month: 'short',
          year: 'numeric',
        });
  }

  /**
   * Cached, stable-reference projection of `relatedNotes` for the Related Notes
   * table. This MUST NOT be a getter: PrimeNG's p-table diffs rows by the
   * identity of the objects in `[value]`, and a getter re-invoked on every
   * Angular change-detection cycle would return brand-new object instances
   * each time, causing the table to tear down and rebuild every row on every
   * tick. That intermittently swaps out a button's DOM node between a click's
   * mousedown and mouseup, making clicks in the table silently fail. Call
   * refreshRelatedNoteObjects() explicitly whenever `relatedNotes` changes.
   */
  relatedNoteObjects: { id: string; title: string; lastModified: string; status: string; aiSummary: AiSummary | null }[] = [];

  private refreshRelatedNoteObjects(): void {
    this.relatedNoteObjects = this.relatedNotes.map((id) => {
      const note = this.data_service.allNotes.find((n) => n._id === id);
      return {
        id,
        title: note?.Title || '',
        lastModified: note?.last_modified || '',
        status: note?.Status || '',
        aiSummary: note?.ai_summary ?? null,
      };
    });
  }

  getAiSummaryTooltip(summary: AiSummary | null): string {
    if (!summary) return '';
    switch (summary.summary_status) {
      case 'current':
      case 'stale':
        return summary.summary_one_sentence || '';
      case 'pending':
        return 'AI summary is being generated…';
      case 'failed':
        return summary.summary_error ? `Summary failed: ${summary.summary_error}` : 'AI summary failed.';
      default:
        return '';
    }
  }

  // ---------------------------------------------------------------
  // AI Summary (read-only) — mirrors ViewComponent's display
  // ---------------------------------------------------------------

  get aiSummary(): AiSummary | null {
    return this.note?.ai_summary ?? null;
  }

  get hasAiSummaryContent(): boolean {
    const summary = this.aiSummary;
    return !!(summary && (summary.summary_one_sentence || summary.summary_paragraph || summary.summary_bullets?.length));
  }

  get aiSummaryButtonLabel(): string {
    if (this.aiSummaryLoading) {
      return 'Generating…';
    }
    return this.hasAiSummaryContent ? 'Update summary' : 'Summarize now';
  }

  private static readonly AI_SUMMARY_POLL_INTERVAL_MS = 4000;
  private static readonly AI_SUMMARY_POLL_TIMEOUT_MS = 60000;

  async generateAiSummary(): Promise<void> {
    if (this.aiSummaryLoading) {
      return;
    }

    const noteId = this.note?._id;
    if (!noteId) {
      this.alertService.warn('Save this note before generating an AI summary.');
      return;
    }

    this.aiSummaryLoading = true;
    try {
      const resp = await firstValueFrom(this.data_service.regenerateAiSummary(noteId));
      if (resp.status !== 'success') {
        this.alertService.error(resp.error?.message || 'Failed to start AI summary generation.');
        return;
      }
      if (resp.data?.queued === false) {
        this.alertService.error('AI summary generation could not be queued. Please try again shortly.');
        return;
      }

      await this.pollAiSummaryStatus(noteId);
    } catch (err: any) {
      const msg = err?.error?.error?.message || err?.error?.message || err?.message || 'AI summary request failed.';
      this.alertService.error(msg);
      console.error('AI summary error:', err);
    } finally {
      this.aiSummaryLoading = false;
    }
  }

  private async pollAiSummaryStatus(noteId: string): Promise<void> {
    const startedAt = Date.now();

    while (Date.now() - startedAt < EditComponent.AI_SUMMARY_POLL_TIMEOUT_MS) {
      await new Promise((resolve) => setTimeout(resolve, EditComponent.AI_SUMMARY_POLL_INTERVAL_MS));

      const statusResp = await firstValueFrom(this.data_service.getAiSummaryStatus(noteId));
      if (statusResp.status !== 'success' || !statusResp.data) {
        this.alertService.warn(statusResp.error?.message || 'Failed to check AI summary status.');
        return;
      }

      const data = statusResp.data;
      if (data.summary_status === 'current') {
        (this.note as any).ai_summary = {
          summary_status: 'current',
          summary_generated_at: data.summary_generated_at ?? undefined,
          summary_model: data.summary_model ?? undefined,
          summary_one_sentence: data.summary?.one_sentence,
          summary_paragraph: data.summary?.paragraph,
          summary_bullets: data.summary?.bullets,
          summary_keywords: data.summary?.keywords,
        };
        this.alertService.success('AI summary generated.');
        return;
      }

      if (data.summary_status === 'failed') {
        this.alertService.error(data.summary_error || 'AI summary generation failed.');
        return;
      }
      // pending/stale/none — keep polling until current, failed, or timeout.
    }

    this.alertService.warn('AI summary is still processing. Check back shortly.');
  }

  aiSummaryStatusIcon(status: string): string {
    switch (status) {
      case 'current':
      case 'stale':
        return 'info';
      case 'pending':
        return 'pending';
      case 'failed':
        return 'error_outline';
      case 'disabled':
        return 'block';
      default:
        return 'help';
    }
  }

  aiSummaryStatusIconClass(status: string): Record<string, boolean> {
    return {
      'edit-ai-summary-icon--stale': status === 'stale',
      'edit-ai-summary-icon--pending': status === 'pending' || status === 'disabled',
      'edit-ai-summary-icon--failed': status === 'failed',
    };
  }

  aiSummaryStatusLabel(status: string): string {
    switch (status) {
      case 'current':
        return 'Current';
      case 'stale':
        return 'Stale';
      case 'pending':
        return 'Pending';
      case 'failed':
        return 'Failed';
      case 'disabled':
        return 'Disabled';
      default:
        return status || 'Unknown';
    }
  }

  relatedNoteRowStyle(status: string): Record<string, string> {
    const isStrikethrough = status === 'Obsolete' || status === 'Cancelled';
    const isMuted = isStrikethrough || status === 'Completed' || status === 'Expired';
    return {
      'font-weight': status === 'Next Action' ? '700' : '400',
      'font-style': isMuted ? 'italic' : 'normal',
      color: isMuted ? 'var(--p-text-muted-color)' : 'var(--p-text-color)',
      'text-decoration': isStrikethrough ? 'line-through' : 'none',
    };
  }

  private stripHtmlToText(html: string): string {
    if (!html) return '';

    return html
      .replace(/<[^>]+>/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  private mapSuggestedTagToTag(suggestedTag: SuggestedTagSelection): Tag {
    const existing = this.availableTags.find((tag) => tag._id === suggestedTag._id);

    if (existing) {
      return existing;
    }

    const fallbackTag: Tag = {
      _id: suggestedTag._id,
      type: 'tag',
      name: suggestedTag.name,
      description: suggestedTag.description || undefined,
      tagType: this.defaultTagType,
      slug: this.slugify(suggestedTag.name),
      color: '#2563EB',
      icon: 'tag',
      parentTagId: null,
      sortOrder: this.getNextTagSortOrder(),
      isActive: true,
    };

    this.upsertAvailableTag(fallbackTag);
    return fallbackTag;
  }

  async copyNoteId(): Promise<void> {
    const id = this.note?._id;

    if (!id) {
      this.snackbarService.showErrorMessage('No ID to copy.');
      return;
    }

    try {
      if (navigator?.clipboard?.writeText) {
        await navigator.clipboard.writeText(id);
        this.snackbarService.showSuccessMessage('ID copied to clipboard.');
        return;
      }

      this.fallbackCopyText(id);
      this.snackbarService.showSuccessMessage('ID copied to clipboard.');
    } catch (error) {
      console.error('Failed to copy note ID', error);
      this.snackbarService.showErrorMessage('Unable to copy ID.');
    }
  }

  private fallbackCopyText(text: string): void {
    const doc = this.elRef.nativeElement.ownerDocument as Document;
    const textarea = this.renderer.createElement('textarea') as HTMLTextAreaElement;

    this.renderer.setProperty(textarea, 'value', text);
    this.renderer.setStyle(textarea, 'position', 'fixed');
    this.renderer.setStyle(textarea, 'top', '-1000px');
    this.renderer.setStyle(textarea, 'left', '-1000px');
    this.renderer.setStyle(textarea, 'opacity', '0');

    this.renderer.appendChild(doc.body, textarea);
    textarea.select();
    doc.execCommand('copy');
    this.renderer.removeChild(doc.body, textarea);
  }
}
